<template>
  <div class="personInfo" :style="{ backgroundImage: `url(${orgBackground})`}">
    <div class="center">
      <div class="top">
        <div class="iconBoxs" @click="toOrderList">
          <img :src="orderBtn" alt="">
          <span>我的订单</span>
        </div>
      </div>
      <div class="main">
        <div class="carOwner">
          <div class="iconBox">
            <div class="titleIcon">
              <div class="imgBox">
                <img
                  src="https://open.zking.com/cms/uploads/45/internet-static/zking-insurance-sales/images/portrait_icon.png"
                  alt=""
                >
              </div>
              <span class="imgTitle">车主信息</span>
            </div>
            <div class="title">
              个人
            </div>
          </div>
          <div class="idCardBox">
            <div v-if="isShowOCR">
              <div class="idBox">
                <span
                  :class="idIndex == '1' ? 'active' : ''"
                  @click="idTab('1')"
                >人像面</span>
                <span
                  :class="idIndex == '2' ? 'active' : ''"
                  @click="idTab('2')"
                >国徽面</span>
              </div>
              <div v-show="idIndex == '1'" class="identify-area">
                <div v-if="!showFrontImg" @change="frontHandleFile($event, '1')">
                  <input
                    ref="fileBtn"
                    type="file"
                    class="refesh-input-file"
                    accept="image/*"
                  >
                </div>
                <div v-if="!showFrontImg" class="idImg">
                  <img :src="zsb_H5MotorNew_camera" alt="">
                  <p>点击上传身份证人像面</p>
                </div>
                <div v-if="showFrontImg" class="new-img">
                  <img
                    ref="frontImage"
                    :src="frontImage"
                    alt=""
                    :style="'transform:rotate(' + frontImageDeg + 'deg)'"
                  >
                </div>
                <div v-if="showFrontImg" class="tool-list">
                  <div class="refesh" @change="frontHandleFile($event, '1')">
                    <input
                      ref="fileBtn"
                      type="file"
                      class="refesh-input-file"
                      accept="image/*"
                    >
                    <img :src="imgUrlRefresh" alt="">
                  </div>
                  <img
                    :src="imgUrlSpinner"
                    alt=""
                    @click="rotateImg('frontImage')"
                  >
                  <img
                    :src="imgUrlEnlarge"
                    alt=""
                    @click="enlargeImg('frontImage')"
                  >
                </div>
              </div>
              <div v-show="idIndex == '2'" class="identify-area">
                <div v-show="!showBackImg" @change="backHandleFile($event, '2')">
                  <input
                    ref="fileBtn"
                    type="file"
                    class="refesh-input-file"
                    accept="image/*"
                  >
                </div>
                <div v-if="!showBackImg" class="idImg">
                  <img :src="zsb_H5MotorNew_camera" alt="">
                  <p>点击上传身份证国徽面</p>
                </div>
                <div v-if="showBackImg" class="new-img">
                  <img
                    ref="backImage"
                    :src="backImage"
                    alt=""
                    :style="'transform:rotate(' + backImageDeg + 'deg)'"
                  >
                </div>
                <div v-show="showBackImg" class="tool-list">
                  <div class="refesh" @change="backHandleFile($event, '2')">
                    <input
                      ref="fileBtn"
                      type="file"
                      class="refesh-input-file"
                      accept="image/*"
                    >
                    <img :src="imgUrlRefresh" alt="">
                  </div>
                  <img
                    :src="imgUrlSpinner"
                    alt=""
                    @click="rotateImg('backImage')"
                  >
                  <img
                    :src="imgUrlEnlarge"
                    alt=""
                    @click="enlargeImg('backImage')"
                  >
                </div>
              </div>
            </div>
            <div class="carInfoBox">
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>车主姓名
                </div>
                <div>
                  <van-field

                    v-model="carOwnerInfo.carOwner"
                    placeholder="请输入车主姓名"
                    input-align="right"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件类型
                </div>
                <div>
                  <van-field
                    v-model="ownerIdentifyType"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击证件类型"
                    @click="ShowPapersTypePup('c1')"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件号码
                </div>
                <div>
                  <van-field
                    v-model="carOwnerInfo.ownerIdentifyNumber"
                    clearable
                    placeholder="请输入证件号码"
                    input-align="right"
                    @blur.native.capture="
                      checkIdentityNumber(
                        ownerIdentifyType,
                        carOwnerInfo.ownerIdentifyNumber,
                        true
                      )
                    "
                  />
                </div>
              </div>

              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>家庭地址
                </div>
                <div>
                  <van-field
                    v-model="carOwnerInfo.ownerAddress"
                    clearable
                    style="width: 2.5rem"
                    placeholder="请输入家庭地址"
                    input-align="right"
                    @blur.native.capture="
                      checkAddress(carOwnerInfo.ownerAddress)
                    "
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>手机号码
                </div>
                <div>
                  <van-field
                    v-model="carOwnerInfo.mobile"
                    placeholder="请输入手机号码"
                    input-align="right"
                    type="tel"
                    maxlength="11"
                    @blur="checkPhoneNum(carOwnerInfo.mobile)"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  电子邮箱
                </div>
                <div>
                  <van-field
                    v-model="carOwnerInfo.email"
                    placeholder="请输入电子邮箱"
                    input-align="right"
                    @blur.native.capture="checkEmail(carOwnerInfo.email)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="insured">
          <div class="iconBox">
            <div class="titleIcon">
              <div class="imgBox">
                <img
                  src="https://open.zking.com/cms/uploads/45/internet-static/zking-insurance-sales/images/portrait_icon.png"
                  alt=""
                >
              </div>
              <span class="imgTitle">被保险人信息</span>
            </div>
            <div class="title">
              个人
            </div>
          </div>
          <div class="idCardBox">
            <div class="carInfoBox">
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>与车主关系
                </div>
                <div>
                  <van-field
                    v-model="recognizeeInData"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击车主关系"
                    @click="ShowPapersTypePup('b1')"
                  />
                </div>
              </div>
              <div
                v-if="reIdCarShow && isShowOCR"
                style="margin-top: 0.1rem; border-bottom: 0.01rem solid #eee"
              >
                <div class="idBox">
                  <span
                    :class="idIndexB == '3' ? 'active' : ''"
                    @click="idTabB('3')"
                  >人像面</span>
                  <span
                    :class="idIndexB == '4' ? 'active' : ''"
                    @click="idTabB('4')"
                  >国徽面</span>
                </div>
                <div v-if="reIdCarShow">
                  <div v-show="idIndexB == '3'" class="identify-area">
                    <div
                      v-if="!showFrontImgb"
                      @change="frontHandleFile($event, '3')"
                    >
                      <input
                        ref="fileBtn"
                        type="file"
                        class="refesh-input-file"
                        accept="image/*"
                      >
                    </div>
                    <div v-if="!showFrontImgb" class="idImg">
                      <img :src="zsb_H5MotorNew_camera" alt="">
                      <p>点击上传身份证人像面</p>
                    </div>
                    <div v-if="showFrontImgb" class="new-img">
                      <img
                        ref="frontImageb"
                        :src="frontImageb"
                        alt=""
                        :style="'transform:rotate(' + frontImagebDeg + 'deg)'"
                      >
                    </div>
                    <div v-if="showFrontImgb" class="tool-list">
                      <div class="refesh" @change="frontHandleFile($event, '3')">
                        <input
                          ref="fileBtn"
                          type="file"
                          class="refesh-input-file"
                          accept="image/*"
                        >
                        <img :src="imgUrlRefresh" alt="">
                      </div>
                      <img
                        :src="imgUrlSpinner"
                        alt=""
                        @click="rotateImg('frontImageb')"
                      >
                      <img
                        :src="imgUrlEnlarge"
                        alt=""
                        @click="enlargeImg('frontImageb')"
                      >
                    </div>
                  </div>
                  <div v-show="idIndexB == '4'" class="identify-area">
                    <div
                      v-if="!showBackImgb"
                      @change="backHandleFile($event, '4')"
                    >
                      <input
                        ref="fileBtn"
                        type="file"
                        class="refesh-input-file"
                        accept="image/*"
                      >
                    </div>
                    <div v-if="!showBackImgb" class="idImg">
                      <img :src="zsb_H5MotorNew_camera" alt="">
                      <p>点击上传身份证国徽面</p>
                    </div>
                    <div v-if="showBackImgb" class="new-img">
                      <img
                        ref="backImageb"
                        :src="backImageb"
                        alt=""
                        :style="'transform:rotate(' + backImagebDeg + 'deg)'"
                      >
                    </div>
                    <div v-if="showBackImgb" class="tool-list">
                      <div class="refesh" @change="backHandleFile($event, '4')">
                        <input
                          ref="fileBtn"
                          type="file"
                          class="refesh-input-file"
                          accept="image/*"
                        >
                        <img :src="imgUrlRefresh" alt="">
                      </div>
                      <img
                        :src="imgUrlSpinner"
                        alt=""
                        @click="rotateImg('backImageb')"
                      >
                      <img
                        :src="imgUrlEnlarge"
                        alt=""
                        @click="enlargeImg('backImageb')"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="reIdCarShow" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>被保人姓名
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.insuredName"
                    placeholder="请输入被保人姓名"
                    input-align="right"
                  />
                </div>
              </div>
              <div v-show="reIdCarShow" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件类型
                </div>
                <div>
                  <van-field
                    v-model="RidentifyType"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击证件类型"
                    @click="ShowPapersTypePup('r1t')"
                  />
                </div>
              </div>
              <div v-show="reIdCarShow" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件号码
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.identifyNumber"
                    clearable
                    placeholder="请输入证件号码"
                    input-align="right"
                    @blur.native.capture="
                      checkIdentityNumber(
                        'rt1',
                        RidentifyType,
                        recognizeeIn.identifyNumber
                      )
                    "
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件有效起期
                </div>
                <div>
                  <van-field
                    readonly
                    name="datetimePicker"
                    :value="recognizeeIn.iDStartDate"
                    placeholder="点击选择时间"
                    @click="choiceValidity(1)"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件有效止期
                </div>
                <div class="carBoxTime">
                  <div>                 
                    <van-field style="padding:.1rem 0">
                      <template #input>
                        <van-checkbox
                          v-model="checkbox"
                          checked-color="#5e2589"
                          direction="horizontal"
                          @change="isCheckout($event, 1)"
                        >
                          长期有效
                        </van-checkbox>
                      </template>
                    </van-field>
                  </div>
                  <div>
                    <van-field
                      style="width: 1.2rem;"
                      readonly
                      :disabled="startDis"
                      name="datetimePicker"
                      :value="recognizeeIn.validDate"
                      placeholder="点击选择时间"
                      @click="choiceValidity(2)"
                    />
                  </div>
                  <!-- <van-field
                    readonly
                    :disabled="startDis"
                    name="datetimePicker"
                    :value="recognizeeIn.validDate"
                    placeholder="点击选择时间"
                    @click="choiceValidity(2)"
                  /> -->
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>出生日期
                </div>
                <div>
                  <van-field
                    readonly
                    clickable
                    name="datetimePicker"
                    :value="recognizeeIn.birthday"
                    placeholder="点击选择时间"
                    :disabled="isRecognizeeIn"
                    @click="choiceValidity(3)"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>性别
                </div>
                <div>
                  <van-field
                    v-model="genderRec"
                    is-link
                    readonly
                    name="picker"
                    :disabled="isRecognizeeIn"
                    @click="ShowPapersTypePup('sex')"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>国籍/地区
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.nationality"
                    is-link
                    readonly
                    name="picker"
                    @click="ShowPapersTypePup('nationalityRec')"
                  />
                </div>
              </div>
              <div class="carBox" :style="{'borderBottom':recognizeeInData=='同车主'? 0: '.01rem solid #eee;'}">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem;">*</span>职业类别
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.occupationName"
                    style="width: 2.5rem"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击职业类别"
                    @click="showOccupation('recognizeeIn')"
                  />
                </div>
              </div>
              <div v-show="reIdCarShow" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>家庭地址
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.address"
                    clearable
                    style="width: 2.5rem"
                    placeholder="请输入家庭地址"
                    input-align="right"
                    @blur.native.capture="checkAddress(recognizeeIn.address)"
                  />
                </div>
              </div>
              <div v-show="reIdCarShow" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>手机号码
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.mobile"
                    placeholder="请输入手机号码"
                    input-align="right"
                    type="tel"
                    maxlength="11"
                    @blur="checkPhoneNum(recognizeeIn.mobile)"
                  />
                </div>
              </div>
              <div v-show="reIdCarShow" class="carBox">
                <div class="carTitle">
                  电子邮箱
                </div>
                <div>
                  <van-field
                    v-model="recognizeeIn.email"
                    placeholder="请输入电子邮箱"
                    input-align="right"
                    @blur.native.capture="checkEmail(recognizeeIn.email)"
                  />
                </div>
              </div>
              <div class="carBox">
                <div class="carTitle">
                  省市区
                </div>
                <div>
                  <van-field
                    v-model="provinceNameRec"
                    is-link
                    readonly
                    name="picker"
                    @click="isShowMotorArea('provinceNameRec')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="policy">
          <div class="iconBox">
            <div class="titleIcon">
              <div class="imgBox">
                <img
                  src="https://open.zking.com/cms/uploads/45/internet-static/zking-insurance-sales/images/portrait_icon.png"
                  alt=""
                >
              </div>
              <span class="imgTitle">投保人信息</span>
            </div>
            <div class="title">
              个人
            </div>
          </div>
          <div class="idCardBox">
            <div class="carInfoBox">
              <div class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>与被保人/车主关系
                </div>
                <div>
                  <van-field
                    v-model="applicantInData"
                    is-link
                    readonly
                    name="picker"
                    @click="ShowPapersTypePup('t1')"
                  />
                </div>
              </div>
              <div
                v-show="!appIdCarShow&&applicantInData !== '同被保人'"
                class="carBox"
              >
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>投保人姓名
                </div>
                <div>
                  <van-field
                    v-model="applicantIn.insuredName"
                    placeholder="请输入投保人姓名"
                    input-align="right"
                    :disabled="isApplicantIn"
                  />
                </div>
              </div>
              <div
                v-show="!appIdCarShow&&applicantInData !== '同被保人'"
                class="carBox"
              >
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件类型
                </div>
                <div>
                  <van-field
                    v-model="AidentifyType"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击证件类型"
                    :disabled="isApplicantIn"
                    @click="ShowPapersTypePup('tz1')"
                  />
                </div>
              </div>
              <div
                v-show="!appIdCarShow&&applicantInData !== '同被保人'"
                class="carBox"
              >
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件号码
                </div>
                <div>
                  <van-field
                    v-model="applicantIn.identifyNumber"
                    clearable
                    placeholder="请输入证件号码"
                    input-align="right"
                    :disabled="isApplicantIn"
                    @blur.native.capture="
                      checkIdentityNumber(
                        AidentifyType,
                        applicantIn.identifyNumber,
                        true
                      )
                    "
                  />
                </div>
              </div>
              <div v-show="applicantInData !== '同被保人'" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件有效起期
                </div>
                <div>
                  <van-field
                    readonly
                    clickable
                    name="datetimePicker"
                    :value="applicantIn.iDStartDate"
                    placeholder="点击选择时间"
                    @click="choiceValidity(4)"
                  />
                </div>
              </div>
              <div v-show="applicantInData !== '同被保人'" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>证件有效止期
                </div>
                <div class="carBoxTime">
                  <div>
                    <van-field style="padding:.1rem 0">
                      <template #input>
                        <van-checkbox
                          v-model="checkboxApp"
                          checked-color="#5e2589"
                          direction="horizontal"
                          @change="isCheckout($event, 2)"
                        >
                          长期有效
                        </van-checkbox>
                      </template>
                    </van-field>
                  </div>
                  <div>
                  <van-field
                      style="width: 1.2rem;"
                      readonly
                      :style="{'color':!startDisApp?'#ccc':''}"
                      :disabled="startDisApp"
                      clickable
                      name="datetimePicker"
                      :value="applicantIn.validDate"
                      placeholder="点击选择时间"
                      @click="choiceValidity(5)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-show="!appIdCarShow&&applicantInData !== '同被保人'"
                class="carBox"
              >
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>出生日期
                </div>
                <div>
                  <van-field
                    readonly
                    clickable
                    name="datetimePicker"
                    :value="applicantIn.birthday"
                    placeholder="点击选择时间"
                    :disabled="isApplicantIn"
                    @click="choiceValidity(6)"
                  />
                </div>
              </div>
              <div
                v-show="!appIdCarShow&&applicantInData !== '同被保人'"
                class="carBox"
              >
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>性别
                </div>
                <div>
                  <van-field
                    v-model="genderApp"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击性别"
                    :disabled="isApplicantIn"
                    @click="ShowPapersTypePup('tSex')"
                  />
                </div>
              </div>
              <div v-show="applicantInData !== '同被保人'" class="carBox">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>国籍/地区
                </div>
                <div>
                  <van-field
                    v-model="applicantIn.nationality"
                    is-link
                    readonly
                    name="picker"
                    @click="ShowPapersTypePup('nationalityApp')"
                  />
                </div>
              </div>
              <div class="carBox" :style="{'borderBottom':appIdCarShow||!appIdCarShow&&applicantInData == '同被保人'?'0':'.01rem solid #eee'}" v-show="applicantInData !== '同被保人'">
                <div class="carTitle">
                  <span style="color: #f29600; padding-right: 0.02rem">*</span>职业类别
                </div>
                <div>
                  <van-field
                    v-model="applicantIn.occupationName"
                    style="width: 2.5rem"
                    is-link
                    readonly
                    name="picker"
                    placeholder="点击职业类别"
                    @click="showOccupation('applicantIn')"
                  />
                </div>
              </div>
              <div v-show="!appIdCarShow&&applicantInData !== '同被保人'">
                <div class="carBox">
                  <div class="carTitle">
                    <span style="color: #f29600; padding-right: 0.02rem">*</span>家庭地址
                  </div>
                  <div>
                    <van-field
                      v-model="applicantIn.address"
                      clearable
                      style="width: 2.5rem"
                      placeholder="请输入家庭地址"
                      input-align="right"
                      @blur.native.capture="checkAddress(applicantIn.address)"
                    />
                  </div>
                </div>
                <div class="carBox">
                  <div class="carTitle">
                    <span style="color: #f29600; padding-right: 0.02rem">*</span>手机号码
                  </div>
                  <div>
                    <van-field
                      v-model="applicantIn.mobile"
                      placeholder="请输入手机号码"
                      input-align="right"
                      type="tel"
                      maxlength="11"
                      @blur="checkPhoneNum(applicantIn.mobile)"
                    />
                  </div>
                </div>
                <div class="carBox">
                  <div class="carTitle">
                    电子邮箱
                  </div>
                  <div>
                    <van-field
                      v-model="applicantIn.email"
                      placeholder="请输入电子邮箱"
                      input-align="right"
                      @blur.native.capture="checkEmail(applicantIn.email)"
                    />
                  </div>
                </div>
              </div>
              <div v-show="applicantInData !== '同被保人'" class="carBox">
                <div class="carTitle">
                  省市区
                </div>
                <div>
                  <van-field
                    v-model="provinceNameApp"
                    is-link
                    readonly
                    name="picker"
                    @click="isShowMotorArea('provinceNameApp')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="btn btnTop" style="margin-right:.1rem" @click="temporary">
        暂存
      </div>
      <div class="btn" @click="nextBtn">
        下一步
      </div>
    </div>
    <!-- 城市弹出层 -->
    <van-popup v-model="showArea" position="bottom" :style="{ height: '40%' }">
      <van-area :area-list="areaList" @confirm="areaConfirmList" @cancel="showArea=false" />
    </van-popup>
    <!-- 证件类型 -->
    <van-popup v-model="showPicker" position="bottom" close-on-click-overlay>
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="unConfirm($event)"
      />
    </van-popup>
    <!-- 证件有效起期 -->
    <van-popup
      v-model="startTimePicker"
      position="bottom"
      close-on-click-overlay
    >
      <van-datetime-picker
        type="date"
        :value="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="birthdaySure($event)"
        @cancel="birthConfig()"
      />
    </van-popup>
    <!-- 证件有效止期 -->
    <van-popup v-model="endTimePicker" position="bottom" close-on-click-overlay>
      <van-datetime-picker
        type="date"
        :value="currentDate"
        :min-date="minDateEnd"
        :max-date="valmaxDateEnd"
        @confirm="birthdaySure($event)"
        @cancel="birthConfig()"
      />
    </van-popup>
    <van-popup
      v-model="IsShowOccupation"
      round
      position="bottom"
      lock-scroll
      :close-on-click-overlay="false"
    >
      <div class="showClose">
        <div class="closeBtn" @click="IsShowOccupationBtn">
          +
        </div>
        <div class="blank">
          <div class="title">
            <span
              @click="levelGoBack()"
            ><van-icon
              name="down"
              class="icon"
            /></span>
            <span v-show="showLevelName1" class="occupation">请选择</span>
            <div v-show="showLevelName2" class="occupation">
              <span>{{ levelName1 ? levelName1 : "请选择" }}</span>
            </div>
            <div v-show="showLevelName3" class="occupation">
              <span>{{ levelName2 ? levelName2 : "请选择" }}</span>
            </div>
          </div>
        </div>
        <div class="content">
          <ul>
            <li
              v-for="(item, index1) in occupationList"
              v-show="showLevelName1"
              :key="item.id"
              @click="getLevelName1(item, index1)"
            >
              {{ item.codecname }}
            </li>
            <li
              v-for="(item, index2) in level2List"
              v-show="showLevelName2"
              :key="item.id"
              @click="getLevelName2(item, index2)"
            >
              {{ item.codecname }}
            </li>
            <li
              v-for="(item, index3) in level3List"
              v-show="showLevelName3"
              :key="item.id"
              @click="getLevelName3(item, index3)"
            >
              {{ item.codecname }}
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import checkFormat from '@/utils/checkFormat.js'
import { getImgBase64 } from '@/utils/imgBlobToBase64.js'
import api from '@/api/api.js'
import Compressor from 'compressorjs'
import Loading from '@/components/Loadings/Loading'
import { Toast, Dialog } from 'vant'
import { removeWatermark, setWaterMark } from '../../watermark'
import { areaDetail } from '@/utils/const.js'
export default {
  components: {
    Loading: Loading
  },
  data() {
    return {
      orderBtn: api.imgAllUrlZSB + '/order-btn.png',
      orgBackground: '',
      occupationList: [], // 职业类别列表
      IsShowOccupation: false, // 控制职业类别选择器
      levelName1: '',
      levelName2: '',
      levelName3: '',
      showLevelName1: true,
      showLevelName2: false,
      showLevelName3: false,
      level2List: [],
      level3List: [],
      personFlag: '',
      iDStartDate: '', // 车主识别的
      validDate: '',
      // 车主信息
      showFrontImg: false, // 展示正面上传照片
      showBackImg: false, // 展示上传的反面照片
      frontImageDeg: 0,
      backImageDeg: 0,
      backImage: '', // 身份证反面照片
      frontImage: '', // 身份证正面照片
      // 车主信息
      // 被保险人信息
      showFrontImgb: false, // 展示正面上传照片
      showBackImgb: false, // 展示上传的反面照片
      frontImagebDeg: 0,
      backImagebDeg: 0,
      backImageb: '', // 身份证反面照片
      frontImageb: '', // 身份证正面照片
      // 被保险人信息
      // 投保信息
      showFrontImgt: false, // 展示正面上传照片
      showBackImgt: false, // 展示上传的反面照片
      frontImagetDeg: 0,
      backImagetDeg: 0,
      backImaget: '', // 身份证反面照片
      frontImaget: '', // 身份证正面照片
      // 投保信息
      switchs: false, // loading显示
      imgUrlEnlarge: api.imgAllUrl + '/img-enlarge.png',
      imgUrlRefresh: api.imgAllUrl + '/img-refesh.png',
      imgUrlSpinner: api.imgAllUrl + '/img-spin.png',
      zsb_H5MotorNew_camera: api.imgAllUrlZSB + '/zsb_H5MotorNew_camera.png',
      idIndex: '1',
      idIndexB: '3',
      idIndexT: '5',
      columns: [],
      showPicker: false,
      carRelationship: '同车主',
      showPickertRel: false,
      columnsRel: ['同车主', '其他'],
      checkbox: false,
      // endTime:new Date(2025, 10, 1),
      startTimePicker: false,
      endTimePicker: false,
      value: '',
      startTime: '',
      endTime: '',
      minDate: new Date(1948, 12, 1),
      maxDate: new Date(2098, 12, 1),
      valmaxDate: new Date(9999, 12, 31), // 证件有效期最大可选
      currentDate: new Date(),
      minDateEnd: new Date(),
      valmaxDateEnd: '',
      timeStatus: '1',
      shipStatus: '',
      ownerIdentifyType: '身份证', // 车主证件类型
      AidentifyType: '身份证', // 投保人证件类型
      RidentifyType: '身份证', // 被保人证件类型
      applicantInData: '同车主', // 当前选择的投保人
      recognizeeInData: '同车主', // 当前选择的被保人
      carOwnerInfo: {
        vehicleOwnerNature: '1', // 车主性质
        carOwner: '', // 车主姓名
        ownerIdentifyType: '01', // 证件类型
        // ownerIdentifyTypeCN: '身份证', // 证件类型名称
        ownerIdentifyNumber: '', // 证件号码
        mobile: '', //
        email: '', //
        ownerAddress: '',
        frontFileId: '',
        backFileId: '',
        sex: '',
        iDStartDate: '', // 证件有效期起期
        birthday: '',
      },
      // 被保人信息
      reIdCarShow: false, // 与车主关系为其他
      // 被保人信息
      genderRec: '', // 性别
      genderArr: [], // 性别数组
      recognizeeIn: {
        address: '',
        birthday: '',
        email: '',
        identifyNumber: '',
        identifyType: '01',
        // identifyTypeCN:'身份证',
        insuredName: '',
        insuredRelationship: '3', // 被保人关系 3同车主 4其他
        mobile: '',
        iDStartDate: '', // 证件有效期起期
        validDate: '',
        occupationCode: '0001001', // 被保人职业代码
        occupationName: '机关内勤(不从事凶险工作)', // 被保人职业名称
        sex: '',
        frontFileId: '',
        backFileId: '',
        insuredType: '1',
        insuredNature: 3, // 客户性质
        insuredFlag: '1',
        insuredIdentity: '01',
        nationality:'中国', //国籍/地区
        countryRegions: 'CHN', //国籍/地区code
        addressProvince:'', //省
        addressPrefecture:'', // 市
        addressCounty: '', //区
      },
      // 投保人信息
      appIdCarShow: true, // 与车主关系为其他
      genderApp: '', // 性别
      checkboxApp: false, // 长期有效
      // 投保人信息
      applicantIn: {
        address: '',
        birthday: '',
        email: '',
        identifyNumber: '',
        identifyType: '01',
        insuredName: '',
        insuredRelationship: '0', // 投保人关系 0同车主 1同被保人 2其他
        mobile: '',
        iDStartDate: '', // 证件有效期起期
        validDate: '',
        occupationCode: '0001001', // 投保人职业代码
        occupationName: '机关内勤(不从事凶险工作)', // 投保人职业名称
        sex: '',
        frontFileId: '',
        backFileId: '',
        insuredType: '1',
        insuredNature: 3, // 客户性质
        insuredFlag: '2',
        insuredIdentity: '01',
        nationality:'中国', //国籍/地区
        countryRegions: 'CHN', //国籍/地区code
        addressProvince:'', //省
        addressPrefecture:'', // 市
        addressCounty : '', //区
      },
      status: '', // 类型状态
      startDis: false, // 被保人证件有效起期
      startDisApp: false, // 投保人证件有效起期
      imgobjs: [], // 证件图片
      insuredList: [], // 投保人被保人合并
      isRecognizeeIn: false,
      isApplicantIn: true,
      imgUrl: api.imgIdUrl,
      mortorQuery: [],
      areaList: {
        province_list: {},
        city_list: {},
        county_list:{}
      }, //省市区
      showArea: false, //省市区弹框
      areaType:'', // 区分投/被保人
      provinceNameRec: '', // 被保人选择的省市区
      provinceNameApp: '', // 投保人选择的省市区
      isDialog:false, //是否弹投保人弹框
      newCinfo:{},
      isShowOCR: null, // 是否显示ocr
      userToken: '',
      isMotorFace: null // 人脸识别开关
    }
  },
  watch: {
    carOwnerInfo: {
      deep: true,
      handler(newval, oldVal) {
        this.assignment()
      }
    },
    'carOwnerInfo.ownerIdentifyNumber'(newVal, oldVal) {
      if (this.recognizeeInData === '同车主' || this.applicantInData === '同车主' || (this.recognizeeInData === '同车主' && this.applicantInData === '同车主')) {
        if (this.RidentifyType === '身份证') {
          if (newVal) {
            if (parseInt(newVal.substr(16, 1)) % 2 === 1) {
              this.genderArr.forEach((valueN) => {
                if (valueN.codecname === '男') {
                  this.recognizeeIn.sex = valueN.codeCode
                  this.applicantIn.sex = valueN.codeCode
                  this.genderRec = valueN.codecname
                  this.genderApp = valueN.codecname
                }
              })
            } else if (
              parseInt(newVal.substr(16, 1)) % 2 ===
              0
            ) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '女') {
                  this.recognizeeIn.sex = value.codeCode
                  this.applicantIn.sex = value.codeCode
                  this.genderRec = value.codecname
                  this.genderApp = value.codecname
                }
              })
            }
            this.recognizeeIn.birthday = checkFormat.identifyNumberToBirthday(
              newVal
            )
            this.applicantIn.birthday = checkFormat.identifyNumberToBirthday(
              newVal
            )
          }
        }
      } else {
        // this.clearRecognizeeIn()
      }
      if (!checkFormat.isEmpty(this.carOwnerInfo.ownerIdentifyNumber) && !checkFormat.isEmpty(this.recognizeeIn.iDStartDate)) {
          let age = checkFormat.calculateAge(this.recognizeeIn.identifyNumber, this.recognizeeIn.iDStartDate)
          console.log(age)
          if (age < 0) {
            this.$toast('请检查证件起期是否正确')
            return false
          }
          if (!checkFormat.isEmpty(age)) {
            const data = this.recognizeeIn.iDStartDate.replaceAll('-', '/')
            this.recognizeeIn.validDate = checkFormat.checkValidDate(age, data)
            if (this.applicantInData === '同车主' || this.applicantInData === '同被保人') {
              this.applicantIn.validDate = checkFormat.checkValidDate(age, data)
            }
            
          }
        }
    },
    "recognizeeIn.iDStartDate": {
      deep: true,
      handler(newDate, oldDate) {
        console.log(newDate, oldDate, 'recognizeeIn.iDStartDate')
        console.log(this.recognizeeIn.iDStartDate, '被保人起期')
        console.log(this.recognizeeIn.identifyNumber, '被保人身份证')
        if (!checkFormat.isEmpty(this.recognizeeIn.identifyNumber) && !checkFormat.isEmpty(this.recognizeeIn.iDStartDate)) {
          let age = checkFormat.calculateAge(this.recognizeeIn.identifyNumber, this.recognizeeIn.iDStartDate)
          console.log(age, '相差的年龄')
          if (age < 0) {
            this.$toast('请检查证件起期是否正确')
            return false
          }
          if (!checkFormat.isEmpty(age)) {
            const data = this.recognizeeIn.iDStartDate.replaceAll('-', '/')
            console.log(this.recognizeeIn.iDStartDate, '要看的iDStartDate')
            this.recognizeeIn.validDate = checkFormat.checkValidDate(age, data)
            console.log(this.recognizeeIn.validDate, '要看的validDate')
          }
        }
      }
    },
    "recognizeeIn.identifyNumber": {
      deep: true,
      handler(newDate, oldDate) {
        console.log(newDate, oldDate, 'recognizeeIn.identifyNumber')
        console.log(this.recognizeeIn.identifyNumber, '被保人起期')
        if (!checkFormat.isEmpty(this.recognizeeIn.identifyNumber) && !checkFormat.isEmpty(this.recognizeeIn.iDStartDate)) {
          let age = checkFormat.calculateAge(this.recognizeeIn.identifyNumber, this.recognizeeIn.iDStartDate)
          console.log(age)
          if (age < 0) {
            this.$toast('请检查证件起期是否正确')
            return false
          }
          if (!checkFormat.isEmpty(age)) {
            const data = this.recognizeeIn.iDStartDate.replaceAll('-', '/')
            this.recognizeeIn.validDate = checkFormat.checkValidDate(age, data)
          }
        }
      }
    },
    'applicantIn.iDStartDate':{
      deep: true,
      handler(newDate, oldDate) {
        console.log(newDate, oldDate, 'applicantIn.iDStartDate')
        if (!checkFormat.isEmpty(this.applicantIn.identifyNumber) && !checkFormat.isEmpty(this.applicantIn.iDStartDate)) {
          let age = checkFormat.calculateAge(this.applicantIn.identifyNumber, this.applicantIn.iDStartDate)
          console.log(age)
          if (age < 0) {
            this.$toast('请检查证件起期是否正确')
            return false
          }
          if (!checkFormat.isEmpty(age)) {
            const data = this.applicantIn.iDStartDate.replaceAll('-', '/')
            this.applicantIn.validDate = checkFormat.checkValidDate(age, data)
            console.log(this.checkbox, this.startDis, this.applicantIn.validDate, '其他')
          }
        } 
      }
    },
    'applicantIn.identifyNumber':{
      deep: true,
      handler(newDate, oldDate) {
        console.log(newDate, oldDate, 'applicantIn.identifyNumber')
        if (!checkFormat.isEmpty(this.applicantIn.identifyNumber) && !checkFormat.isEmpty(this.applicantIn.iDStartDate)) {
          let age = checkFormat.calculateAge(this.applicantIn.identifyNumber, this.applicantIn.iDStartDate)
          console.log(age)
          if (age < 0) {
            this.$toast('请检查证件起期是否正确')
            return false
          }
          if (!checkFormat.isEmpty(age)) {
            const data = this.applicantIn.iDStartDate.replaceAll('-', '/')
            this.applicantIn.validDate = checkFormat.checkValidDate(age, data)
            console.log(this.checkbox, this.startDis, this.applicantIn.validDate, '其他')
          }
        } 
      }
    },
    'checkbox'(newVal, oldVal) {
      if (this.carOwnerInfo.carOwner === this.applicantIn.insuredName && this.applicantInData === '同车主' && this.recognizeeInData === '同车主') {
        this.checkboxApp = newVal
      }
    },
    recognizeeIn: {
      deep: true,
      handler(newval, oldVal) {
        this.recognizeeInassignment()
        if (this.RidentifyType === '身份证') {
          if (newval.identifyNumber) {
            if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 1) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '男') {
                  newval.sex = value.codeCode
                  this.genderRec = value.codecname
                  this.carOwnerInfo.sex = value.codeCode
                }
              })
            } else if (
              parseInt(newval.identifyNumber.substr(16, 1)) % 2 ===
              0
            ) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '女') {
                  newval.sex = value.codeCode
                  this.genderRec = value.codecname
                  this.carOwnerInfo.sex = value.codeCode
                }
              })
            }
            this.recognizeeIn.birthday = checkFormat.identifyNumberToBirthday(
              this.recognizeeIn.identifyNumber
            )
            this.carOwnerInfo.birthday = checkFormat.identifyNumberToBirthday(
              this.recognizeeIn.identifyNumber
            )
          }
        } else {
          this.isRecognizeeIn = false
        }
      }

    },
    applicantIn: {
      deep: true,
      handler(newval, oldVal) {
        this.applicantInDataList()
        if (this.AidentifyType === '身份证') {
          if (newval.identifyNumber) {
            if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 1) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '男') {
                  newval.sex = value.codeCode
                  this.genderApp = value.codecname
                }
              })
            } else if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 0) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '女') {
                  newval.sex = value.codeCode
                  this.genderApp = value.codecname
                }
              })
            }
            this.applicantIn.birthday = checkFormat.identifyNumberToBirthday(
              this.applicantIn.identifyNumber
            )
          }
        } else {
          this.isApplicantIn = false
        }
      }
    }
  },

  created() {
    this.userToken = localStorage.getItem('setToken') || checkFormat.getUrlKey('token')
    let time = new Date()
    time = time.setFullYear(time.getFullYear() + 20)
    this.valmaxDateEnd = new Date(time)
  },
  mounted() {
    // console.log('mounted')
    this.getGender()
    this.getCodeType()
  },
  activated() {
    if (localStorage.getItem('setMotorAreaName') === 'HU_NAN') {
      this.motorFaceRecognition() // 是否人脸识别
    }
    this.getUpProvinceCom()
    this.newCinfo = JSON.parse(localStorage.getItem('cInfo'))
    this.newCinfo.identifyType = '身份证'
    console.log(this.$store.state.motorOrderDetail, '详情activated')
    // console.log(this.$store.state.itemFileDataList, '=active=>')
    console.log(this.$store.state.carOwnerInfo);
    console.log(this.$store.state.insuredList);
    this.$store.commit('set_motorStep', '2')
    this.$store.commit('set_showStep', true)
    if (this.$store.state.motorOrderDetail && Object.keys(this.$store.state.motorOrderDetail).length > 0 && this.$store.state.motorOrderDetail.carOwnerInfo && this.$store.state.motorOrderDetail.carOwnerInfo !== null && Object.keys(this.$store.state.motorOrderDetail.carOwnerInfo).length > 0) {
      this.getMortorQuery(this.$store.state.motorOrderDetail)
      this.mortorQuery = this.$store.state.motorOrderDetail
    } else {
      const ownerIdentifyType = {
        '01': '身份证',
        '03': '护照',
        '04': '军人证',
        '10': '组织机构代码',
        '550': '港澳台居民居住证',
        '13': '统一社会信用代码',
        '41': '港澳通行证',
        '553': '外国人永久居留身份证',
        '511': '台湾居民来往大陆通行证'
      }
      if (this.$store.state.carOwnerInfo && Object.keys(this.$store.state.carOwnerInfo).length > 0) {
        this.carOwnerInfo = this.$store.state.carOwnerInfo
        this.ownerIdentifyType = ownerIdentifyType[this.$store.state.carOwnerInfo.ownerIdentifyType] || ''
      } else {
        const newCinfo = JSON.parse(localStorage.getItem('cInfo'))
        this.carOwnerInfo.carOwner = newCinfo.name
        this.carOwnerInfo.ownerIdentifyNumber = newCinfo.identifyNum
        this.carOwnerInfo.mobile = newCinfo.phoneNumber
        this.applicantIn.identifyNumber = newCinfo.identifyNum
        if (this.recognizeeInData === '同车主' && this.applicantInData === '同车主') {
          this.applicantIn.identifyNumber = newCinfo.identifyNum
          this.applicantIn.insuredName = newCinfo.name
          this.recognizeeIn.identifyNumber = newCinfo.identifyNum
          this.recognizeeIn.insuredName = newCinfo.name
          // console.log(this.genderArr,cInfo.gender,'????');
          if (this.ownerIdentifyType === '身份证') {
            this.isRecognizeeIn = true
          }
        }
      }
      console.log(this.$store.state.insuredList, '人员信息')
      if (this.$store.state.insuredList && this.$store.state.insuredList.length > 0) {
        let recognizeeIn = []
        let applicantIn = []
        recognizeeIn = this.$store.state.insuredList.find(item => {
          return item.insuredRelationship === '3' || item.insuredRelationship === '4'
        })
        applicantIn = this.$store.state.insuredList.find(item => {
          return item.insuredRelationship !== '3' || item.insuredRelationship !== '4'
        })
        this.recognizeeIn = recognizeeIn
        this.applicantIn = applicantIn
        const obj = {
          '0': '同车主',
          '1': '同被保人',
          '2': '其他',
          '3': '同车主',
          '4': '其他'
        }
        recognizeeIn.occupationName = this.occupation(recognizeeIn.occupationCode)
        applicantIn.occupationName = this.occupation(applicantIn.occupationCode)
        // console.log(recognizeeIn, 'recognizeeIn')// 被保人
        // console.log(applicantIn, 'applicantIn')// 投保人
        this.recognizeeIn = recognizeeIn
        this.genderRec = recognizeeIn.sex === '1' ? '男' : '女'
        // console.log(this.genderRec, 'this.genderRec')
        this.applicantIn = applicantIn
        // recognizeeIn.insuredRelationship = '4'
        // applicantIn.insuredRelationship = '2'
        if (recognizeeIn.insuredRelationship && applicantIn.insuredRelationship) {
          this.recognizeeInData = obj[recognizeeIn.insuredRelationship]
          this.applicantInData = obj[applicantIn.insuredRelationship]
        }
        if (this.recognizeeInData === '同车主') {
          this.RidentifyType = ownerIdentifyType[this.carOwnerInfo.ownerIdentifyType]
        } else {
          this.RidentifyType = ownerIdentifyType[recognizeeIn.identifyType]
        }
        // console.log(this.recognizeeInData, 'this.recognizeeInData==')
        // console.log(this.applicantIn, 'this.applicantIn===')
        this.reIdCarShow = this.recognizeeInData === '其他'
        this.appIdCarShow = this.applicantInData !== '其他'
      }
      const cInfo = Object.assign({ }, JSON.parse(localStorage.getItem('cInfo')))
      cInfo.name = checkFormat.hideInsurantName(1, cInfo.name)
      cInfo.identifyNum = checkFormat.hideInsurantName(3, cInfo.identifyNum)
      setWaterMark(cInfo.name + '-' + cInfo.identifyNum)
    }
    if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList[0] && this.$store.state.itemFileDataList[0].fileList && this.$store.state.itemFileDataList[0].fileList.length > 0) {
      this.$store.commit('setItemFileDataList', this.$store.state.itemFileDataList)
      this.lastImgShow(this.$store.state.itemFileDataList)
    }
    const objOCR = areaDetail.find(El => { return El.comName === localStorage.getItem('setMotorAreaName') })
    this.isShowOCR = objOCR.isShowOCR
  },
  deactivated() {
    removeWatermark()
  },
  methods: {
    motorFaceRecognition() { // 是否需要人脸识别1开0关2没有人脸识别
      const params = {
        comCode: '2430000000',
        configCode: 'HX_MOTO_FACEID'
      }
      this.$http.post(api.queryConfigAssist, params).then(res => {
        console.log(res.data, 'jjjjjkkkk')
        if (res.data && res.data.length > 0) {
          if (res.data[0].validStatus === '1') {
            this.isMotorFace = res.data[0].configValue
          } else {
            this.isMotorFace = null
          }
        } else {
          this.isMotorFace = null
        }
      }).catch(err => {
        console.log(err, '接口报错')
        this.isMotorFace = null
      })
    },
    areaConfirmList(value) {
      console.log(value);
      console.log(this.areaType, '12');
      if (value.length > 0) {
        let provin = ''
        if (value[value.length -1] === undefined || value[value.length -1] === null || value[value.length -1] === '') {
          value.splice(2, 0, {code:'', name:''})
        } 
        console.log(value, 'code');
        provin = value[2].name === '' ? value[0].name + '-' + value[1].name : value[0].name + '-' + value[1].name + '-' + value[2].name
        this[this.areaType] = provin
        if (this.areaType === 'provinceNameRec') {
          console.log('provinceNameRec');
          this.recognizeeIn.addressProvince = value[0].code
          this.recognizeeIn.addressPrefecture = value[1].code
          this.recognizeeIn.addressCounty = value[2].code
        } else {
          console.log('provinceNameApp');
          this.applicantIn.addressProvince = value[0].code
          this.applicantIn.addressPrefecture = value[1].code
          this.applicantIn.addressCounty = value[2].code
          console.log(this.applicantIn, 'this.applicantIn');
        }
      }
      console.log(this.recognizeeIn, 'areaRec');
      console.log(this.applicantIn, 'areaApp');
      this.showArea = false
    },  
    getUpProvinceCom() { // 查询省市区
      const provParam = {
        codeType: 'AdminDivisionCode',
        // codeLevel: '2'
      }
      this.switchs = true
      this.$http.post(api.getByCodeType, provParam).then(res => {
        // console.log(res.data, '0009899999');
        if (res.data && res.data.length > 0) {
          let resProvData = res.data
          for (const i in resProvData) {
            if (resProvData[i].codeLevel === '2') {
              this.areaList.province_list[resProvData[i].codeCode] = resProvData[i].codecname
            }
            if (resProvData[i].codeLevel === '3') {
              this.areaList.city_list[resProvData[i].codeCode] = resProvData[i].codecname
            }
            if (resProvData[i].codeLevel === '4') {
              this.areaList.county_list[resProvData[i].codeCode] = resProvData[i].codecname
            }
          }
          let recogn = {
            addressProvince:'', //省
            addressPrefecture:'', // 市
            addressCounty : '', //区
          }
          let appli = {
            addressProvince:'', //省
            addressPrefecture:'', // 市
            addressCounty : '', //区
          }
          if (this.recognizeeIn.addressProvince) {
            recogn.addressProvince = this.areaList.province_list[this.recognizeeIn.addressProvince]
          }
          if (this.recognizeeIn.addressPrefecture) {
            recogn.addressPrefecture = this.areaList.city_list[this.recognizeeIn.addressPrefecture]
          }
          if (this.recognizeeIn.addressCounty) {
            recogn.addressCounty = this.areaList.county_list[this.recognizeeIn.addressCounty]
          }
          if (this.recognizeeIn.addressProvince && this.recognizeeIn.addressPrefecture && this.recognizeeIn.addressCounty) {
            if ((recogn.addressCounty === '' || recogn.addressCounty=== undefined || recogn.addressCounty === null) && !this.recogn.addressProvince) {
              this.provinceNameRec = recogn.addressProvince + '-' + recogn.addressPrefecture
            } else {
              this.provinceNameRec = recogn.addressProvince + '-' + recogn.addressPrefecture + '-' + recogn.addressCounty
            }
          }

          if (this.applicantIn.addressProvince) {
            appli.addressProvince = this.areaList.province_list[this.applicantIn.addressProvince]
          }
          if (this.applicantIn.addressPrefecture) {
            appli.addressPrefecture = this.areaList.city_list[this.applicantIn.addressPrefecture]
          }
          if (this.applicantIn.addressCounty) {
            appli.addressCounty = this.areaList.county_list[this.applicantIn.addressCounty]
          }
          if (this.applicantIn.addressProvince && this.applicantIn.addressPrefecture && this.applicantIn.addressCounty) {
            if (appli.addressCounty === '' || appli.addressCounty === undefined || appli.addressCounty === null) {
              this.provinceNameApp = appli.addressProvince + '-' + appli.addressPrefecture
            } else {
              this.provinceNameApp = appli.addressProvince + '-' + appli.addressPrefecture + '-' + appli.addressCounty
            }
          }

          console.log(recogn, 'recogn');
          console.log(appli, 'recogn');
        } else {
          this.$toast('省市区请求失败')
        }
        this.switchs = false
      })
      .catch(error => {
        console.log(error)
      })
    },
    isShowMotorArea(type) {
      this.areaType = type
      this.showArea = true
      console.log(this.areaType);
      console.log(this.areaList, '000000999');
    },
    temporary(type) {
      // console.log(this.$store.state.itemFileDataList, 'temporary')
      // alert('暂存啊')
      // this.$store.commit('set_motorStep', '3')
      this.applicantIn.insuredNature = '3'
      this.recognizeeIn.insuredNature = '3'
      this.recognizeeIn.insuredFlag = '1'
      this.applicantIn.insuredFlag = '2'
      this.applicantIn.insuredType = '1'
      this.recognizeeIn.insuredType = '1'
      // console.log(this.recognizeeIn, 'this.recognizeeInzuihou')
      this.insuredList = []
      this.insuredList.push(this.applicantIn)
      this.insuredList.push(this.recognizeeIn)

      const JQfile = {
        businessNo: null,
        riskCode: '0591'
      }
      this.carOwnerInfo = {
        carOwner: this.carOwnerInfo.carOwner,
        email: this.carOwnerInfo.email,
        mobile: this.carOwnerInfo.mobile,
        ownerAddress: this.carOwnerInfo.ownerAddress,
        ownerIdentifyNumber: this.carOwnerInfo.ownerIdentifyNumber,
        ownerIdentifyType: this.carOwnerInfo.ownerIdentifyType,
        // ownerIdentifyTypeCN: this.carOwnerInfo.ownerIdentifyTypeCN,
        vehicleOwnerNature: '1'
      }
      const params = {
        carOwnerInfo: this.carOwnerInfo, // 车主信息
        vehicleInfo: this.$store.state.motorBaseInfo, // 车辆信息
        orderId: this.$store.state.motorOrderId, // 订单id
        terminalId: 'H5',
        orderOrigin: 'DP_OWXPA',
        channelCode: 'DP_OWXPA',
        productCode: 'motor_product',
        productName: '摩托车险',
        insuredList: this.insuredList
      }
      this.$store.commit('setCarOwnerInfo', params.carOwnerInfo)
      this.$store.commit('setInsuredList', params.insuredList)
      console.log(this.imgobjs, '-')
      if (this.imgobjs.length > 0) {
        const imageInfoLists = []
        if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList.length > 0 && this.$store.state.itemFileDataList[0].fileList[0].fileId !== '') {
          this.$store.state.itemFileDataList[0].fileList.forEach(value => {
            imageInfoLists.push({
              fileId: value.fileId,
              fileType: value.fileType,
              fileName: value.fileName
            })
          })
        }
        this.imgobjs.forEach(value => {
          imageInfoLists.push({
            fileId: value.fileId,
            fileType: value.fileType,
            fileName: value.fileName
          })
        })
        if (imageInfoLists.length !== 0) {
          JQfile.fileList = imageInfoLists
        }
      } else {
        if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList.length > 0) {
          params.itemFileDataList = this.$store.state.itemFileDataList
        }
      }
      // console.log(JQfile, '==JQfile=>')
      if (JQfile.fileList) {
        const JQfiles = []
        JQfiles.push(JQfile)
        params.itemFileDataList = JQfiles
      }
      if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList.length > 0) {
        params.itemFileDataList[0].fileList = this.reduces(params.itemFileDataList[0].fileList)
      }
      console.log(params, '暂存数据')
      if (type === 'save') {
        this.$store.commit('setItemFileDataList', params.itemFileDataList)
        if (this.isMotorFace === '0') {
          this.$router.push(`/motor/personFace?isMotorFace=${this.isMotorFace}`)
        } else {
          this.$store.commit('set_motorStep', '3')
        }
      } else {
        this.switchs = true
        this.$http.post(api.motorSava, params).then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            this.$store.commit('setItemFileDataList', res.data.resultObj.itemFileDataList)
            if (type === 'save') {
              if (this.isMotorFace === '0') {
                this.$router.push(`/motor/personFace?isMotorFace=${this.isMotorFace}`)
              } else {
                this.$store.commit('set_motorStep', '3')
              }
            }
            if (type === 'orderList') {
              this.$router.push('/motor/orderList')
            }
            this.imgobjs = {
              fileId: '',
              fileType: ''
            }
            this.switchs = false
          } else {
            this.$toast(res.data.rtnMsg)
            this.switchs = false
          }
        })
          .catch(err => {
            this.$toast('请求失败')
            console.log(err)
            this.switchs = false
          })
      }
      this.$store.commit('setCarOwnerInfo', this.carOwnerInfo)
      this.$store.commit('setInsuredList', this.insuredList)
      this.$store.commit('setApplicantIn', this.applicantIn)
      this.$store.commit('setRecognizeeIn', this.recognizeeIn)
    },
    reduces(arr) {
      const list = {}
      arr = arr.reduce((total, next) => {
        list[next.fileId] ? '' : list[next.fileId] = true && total.push(next)
        return total
      }, [])
      // console.log(arr, 'arrAarry')
      return arr
    },
    getMortorQuery(data) {
      console.log('进入赋值')
      // console.log(this.recognizeeIn.occupationName, '1')
      // console.log(this.recognizeeIn.occupationCode, '1')
      // console.log(data, '详情')
      const ownerIdentifyType = {
        '01': '身份证',
        '03': '护照',
        '04': '军人证',
        '10': '组织机构代码',
        '550': '港澳台居民居住证',
        '13': '统一社会信用代码',
        '41': '港澳通行证',
        '553': '外国人永久居留身份证',
        '511': '台湾居民来往大陆通行证',
      }
      this.carOwnerInfo = data.carOwnerInfo || {}
      if (data.carOwnerInfo && Object.keys(data.carOwnerInfo).length > 0) {
        this.ownerIdentifyType = ownerIdentifyType[data.carOwnerInfo.ownerIdentifyType] || ''
      }
      let recognizeeIn = []
      let applicantIn = []
      if (data.insuredList && data.insuredList.length > 0) {
        // data.insuredList[1].insuredRelationship = '3'
        recognizeeIn = data.insuredList.find(item => {
          return item.insuredRelationship === '3' || item.insuredRelationship === '4'
        })
        applicantIn = data.insuredList.find(item => {
          return item.insuredRelationship !== '3' || item.insuredRelationship !== '4'
        })
      }
      // data.insuredList[0].insuredRelationship = '3'
      const obj = {
        '0': '同车主',
        '1': '同被保人',
        '2': '其他',
        '3': '同车主',
        '4': '其他'
      }
      recognizeeIn.occupationName = this.occupation(recognizeeIn.occupationCode)
      applicantIn.occupationName = this.occupation(applicantIn.occupationCode)
      // console.log(recognizeeIn, 'recognizeeIn')// 被保人
      // console.log(applicantIn, 'applicantIn')// 投保人
      this.recognizeeIn = recognizeeIn
      this.genderRec = recognizeeIn.sex === '1' ? '男' : '女'
      // console.log(this.genderRec, 'this.genderRec')
      this.applicantIn = applicantIn
      // recognizeeIn.insuredRelationship = '4'
      // applicantIn.insuredRelationship = '2'
      if (recognizeeIn.insuredRelationship && applicantIn.insuredRelationship) {
        this.recognizeeInData = obj[recognizeeIn.insuredRelationship]
        this.applicantInData = obj[applicantIn.insuredRelationship]
      }
      if (this.recognizeeInData === '同车主') {
        this.RidentifyType = ownerIdentifyType[data.carOwnerInfo.ownerIdentifyType]
      } else {
        this.RidentifyType = ownerIdentifyType[recognizeeIn.identifyType]
      }
      console.log(this.recognizeeInData, 'this.recognizeeInData==')
      console.log(this.applicantIn, 'this.applicantIn===')
      this.reIdCarShow = this.recognizeeInData === '其他'
      this.appIdCarShow = this.applicantInData !== '其他'
    },
    lastImgShow(imgList) {
      console.log(this.imgobjs, 'hhahah')
      console.log(imgList, '图片')
      const lastImg = imgList[0].fileList.filter(item => {
        return item.fileType === '53'
      })
      console.log(lastImg, 'lastImg')
      console.log(this.idIndex, 'this.idIndex')
      console.log(this.idIndexB, 'this.idIndexB')
      if (lastImg.length > 0) {
        const front1 = lastImg.find(x => x.fileName && x.fileName.substring(0, 1) === '1') || {}
        const front2 = lastImg.find(x => x.fileName && x.fileName.substring(0, 1) === '2') || {}
        this.showFrontImg = Object.keys(front1).length > 0 && front1.fileId
        this.showBackImg = Object.keys(front2).length > 0 && front2.fileId
        const front3 = lastImg.find(x => x.fileName && x.fileName.substring(0, 1) === '3') || {}
        const front4 = lastImg.find(x => x.fileName && x.fileName.substring(0, 1) === '4') || {}
        this.showFrontImgb = Object.keys(front3).length > 0 && front3.fileId
        this.showBackImgb = Object.keys(front4).length > 0 && front4.fileId
        // let obj = {
        //   '1': 'frontImage',
        //   '2': 'backImage',
        //   '3': 'frontImageb',
        //   '4': 'showBackImgb'
        // }
        // checkFormat.imgFile(this.imgUrl + front1.fileId).then(res => {
        //   this[obj[this.idIndex]] = res
        // })
        // return
        this.$nextTick(async() => {
          if (this.idIndex === '1') {
            if (front1.fileId) {
              // downloadFile(this.imgUrl + front1.fileId, this.userToken).then(res => {
              //   this.frontImage = res
              // })
              this.frontImage = await getImgBase64(this.imgUrl + front1.fileId, this.userToken)
            }
          }
          if (this.idIndex === '2') {
            if (front2.fileId) {
              // downloadFile(this.imgUrl + front2.fileId, this.userToken).then(resBack => {
              //   this.backImage = resBack
              // })
              this.backImage = await getImgBase64(this.imgUrl + front2.fileId, this.userToken)
            }
          }
          if (this.idIndexB === '3') {
            if (front3.fileId) {
              // downloadFile(this.imgUrl + front3.fileId, this.userToken).then(resFront => {
              //   this.frontImageb = resFront
              // })
              this.frontImageb = await getImgBase64(this.imgUrl + front3.fileId, this.userToken)
            }
          }
          if (this.idIndexB === '4') {
            if (front4.fileId) {
              // downloadFile(this.imgUrl + front4.fileId, this.userToken).then(resBacks => {
              //   this.backImageb = resBacks
              // })
              this.backImageb = await getImgBase64(this.imgUrl + front4.fileId, this.userToken, this.userToken)
            }
          }
        })
        this.recognizeeInData = '其他'
        this.reIdCarShow = true
      }
    },
    occupation(codeCode) {
      if (this.occupationList && this.occupationList.length > 0) {
        let codecname = ''
        this.occupationList.forEach(item => {
          if (item.codeCode === codeCode) {
            codecname = item.codecname
          } else {
            item.levelTwoList.forEach(itemTwo => {
              if (itemTwo.codeCode === codeCode) {
                codecname = itemTwo.codecname
              } else {
                itemTwo.levelThreeList.forEach(itemLast => {
                  if (itemLast.codeCode === codeCode) {
                    codecname = itemLast.codecname
                  }
                })
              }
            })
          }
        })
        // console.log(codecname, 'codecname')
        return codecname
      }
    },
    changOther() {
      // console.log('进入了changOther方法了啊')
      this.applicantIn.insuredRelationship = '2'
      this.applicantInData = '其他'
      this.appIdCarShow = false
      const newCinfo = JSON.parse(localStorage.getItem('cInfo'))
      this.applicantIn.identifyNumber = newCinfo.identifyNum
      this.applicantIn.insuredName = newCinfo.name
      this.applicantIn.mobile = newCinfo.phoneNumber
      this.genderApp = newCinfo.gender
      this.applicantIn.birthday = checkFormat.identifyNumberToBirthday(
        newCinfo.identifyNum
      )
      // this.applicantIn.validDate = 
      this.genderArr.forEach((value) => {
        if (value.codecname === this.genderApp) {
          this.applicantIn.sex = value.codeCode
          // this.sexs = value.codecname
        }
      })
    },
    changeOwn() {
      // console.log('345');
      this.applicantIn.insuredRelationship = '0'
      this.applicantInData = '同车主'
      this.appIdCarShow = true
      this.isRecognizeeIn = true
      // this.reIdCarShow = true
      // this.recognizeeInData = '其他'
      // this.recognizeeIn.insuredRelationship = '4'
    },
    yearDiff(age, title) {
      let message = ''
      if (age < 16) {
        message = title + '身份证有效期的年限有误，请检查!(未满16周岁的公民申领的居民身份证有效期为5年)';
      } else if (age >= 16 && age <= 25 ) {
        message = title + '身份证有效期的年限有误，请检查!(年满16周岁至25周岁的公民申领的居民身份证有效期为10年)';
      } else if (age >= 26 && age <= 45) {
        message = title + '身份证有效期的年限有误，请检查!(年满26周岁至45周岁的公民申领的居民身份证有效期为20年)';
      } else if (age > 45) {
        message = title + '身份证有效期的年限有误，请检查!(年满46周岁的公民申领居民身份证有效期为长期)';
      }
      return message
    },
    nextBtn() {
      console.log(this.isMotorFace, 'hjjjjj')
      // console.log(this.carOwnerInfo, 'carOwnerInfo')
      // console.log(this.applicantIn, 'applicantInData')
      // console.log(this.recognizeeIn, 'recognizeeIn')
      // console.log(this.recognizeeIn.validDate === null, 'this.recognizeeIn.validDate');
      // console.log(this.recognizeeIn.validDate === undefined, 'this.recognizeeIn.validDate');
      // console.log(this.recognizeeIn.validDate === '', 'this.recognizeeIn.validDate');
      // console.log(this.RidentifyType, 'this.recognizeeIn.validDate');
      // 校验车主信息
      if (this.carOwnerInfo.carOwner === '' || this.carOwnerInfo.carOwner === null) {
        this.$toast('请输入车主姓名')
        return false
      } else if (this.carOwnerInfo.ownerIdentifyNumber === '' || this.carOwnerInfo.ownerIdentifyNumber === null) {
        this.$toast('请输入车主证件号码')
        return false
      } else if (this.carOwnerInfo.ownerAddress === '' || this.carOwnerInfo.ownerAddress === null) {
        this.$toast('请输入车主家庭地址')
        return false
      } else if (this.carOwnerInfo.mobile === '' || this.carOwnerInfo.mobile === null) {
        this.$toast('请输入车主手机号码')
        return false
      }
      // 校验被保人信息
      if (this.recognizeeIn.insuredName === '' || this.recognizeeIn.insuredName === null) {
        this.$toast('请输入被保人姓名')
        return false
      } else if (this.recognizeeIn.identifyNumber === '' || this.recognizeeIn.identifyNumber === null) {
        this.$toast('请输入被保人证件号码')
        return false
      } else if (this.reIdCarShow && (this.recognizeeIn.mobile === '' || this.recognizeeIn.mobile === null)) {
        this.$toast('请输入被保人手机号码')
        return false
      } else if (this.recognizeeIn.iDStartDate === '' || this.recognizeeIn.iDStartDate === null) {
        this.$toast('请选择被保人证件有效起期')
        return false
      } else if (this.recognizeeIn.validDate === '' || this.recognizeeIn.validDate === null) {
        this.$toast('请选择被保人证件有效止期')
        return false
      }
      // else if (this.RidentifyType === '身份证') {
      //   if (
      //     this.recognizeeIn.iDStartDate === '' ||
      //     this.recognizeeIn.iDStartDate === null
      //   ) {
      //     this.$toast('请选择被保人证件有效起期')
      //     return false
      //   }
      //   if (
      //     this.recognizeeIn.validDate === '' ||
      //     this.recognizeeIn.validDate === null
      //   ) {
      //     this.$toast('请选择被保人证件有效止期')
      //     return false
      //   }
      // } 
      else if (this.recognizeeIn.birthday === '' || this.recognizeeIn.birthday === null) {
        this.$toast('请选择被保人出生日期')
        return false
      } else if (this.reIdCarShow && (this.recognizeeIn.address === '' || this.recognizeeIn.address === null)) {
        this.$toast('请输入被保人地址')
        return false
      } else if (this.recognizeeIn.sex === '' || this.recognizeeIn.sex == null) {
        this.$toast('被保人性别不能为空')
        return false
      } 
      if (this.recognizeeIn.occupationName === '' || this.recognizeeIn.occupationName == null) {
        this.$toast('被保人职业类别不能为空')
        return false
      }
      // 校验投保人信息
      if (this.applicantInData === '其他' && (this.applicantIn.insuredName === '' || this.applicantIn.insuredName === null)) {
        this.$toast('请输入投保人姓名')
        return false
      } else if (this.applicantInData === '其他' && (this.applicantIn.identifyNumber === '' || this.applicantIn.identifyNumber === null)) {
        this.$toast('请输入投保人证件号码')
        return false
      } else if (this.applicantInData === '其他' && (this.applicantIn.mobile === '' || this.applicantIn.mobile === null)) {
        this.$toast('请输入投保人手机号码')
        return false
      } else if (this.AidentifyType === '身份证' && this.applicantInData !== '同被保人') {
        if (
          this.applicantIn.iDStartDate === '' ||
          this.applicantIn.iDStartDate === null
        ) {
          this.$toast('请选择投保人证件有起效期')
          return false
        }
        if (
          this.applicantIn.validDate === '' ||
          this.applicantIn.validDate === null
        ) {
          this.$toast('请选择投保人证件有效止期')
          return false
        }
      } else if (this.applicantInData === '其他' && (this.applicantIn.birthday === '' || this.applicantIn.birthday === null)) {
        this.$toast('请选择投保人出生日期')
        return false
      } else if (this.applicantInData === '其他' && (this.applicantIn.address === '' || this.applicantIn.address === null)) {
        this.$toast('请输入投保人家庭地址')
        return false
      }
      if (this.applicantIn.occupationName === '' || this.applicantIn.occupationName == null) {
        this.$toast('投保人职业类别不能为空')
        return false
      }
      if (!this.checkEmail(this.carOwnerInfo.email, true)) {
        return false
      }
      if (!this.checkEmail(this.recognizeeIn.email, true)) {
        return false
      }
      if (!this.checkEmail(this.applicantIn.email, true)) {
        return false
      }
      if (!this.checkAddress(this.carOwnerInfo.ownerAddress, true)) {
        return false
      }
      if (!this.checkAddress(this.recognizeeIn.address, true)) {
        return false
      }
      if (this.applicantInData === '其他') {
        if (!this.checkAddress(this.applicantIn.address, true)) {
          return false
        }
      }
      if (this.recognizeeInData === '其他' && this.recognizeeIn.birthday !== '') {
        if (checkFormat.getDate(this.recognizeeIn.birthday) === 'NaN-NaN-NaN NaN时') {
          this.$toast('被保人出生日期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      // this.recognizeeInData === '其他' && 
      if (this.recognizeeIn.validDate !== '') {
        if (this.recognizeeIn.validDate < checkFormat.getTimeToDate(new Date())) {
          this.$toast('被保人证件有效期不能早于当前日期！')
          return false
        }
      }
      // this.recognizeeInData === '其他' && 
      if (this.recognizeeIn.validDate !== '') {
        if (checkFormat.getDate(this.recognizeeIn.validDate) === 'NaN-NaN-NaN NaN时') {
          this.$toast('被保人证件有效期不能小于1或大于当前月的最大天数')
          return false
        }
      }

      if (this.applicantInData === '其他' && this.applicantIn.birthday !== '') {
        if (checkFormat.getDate(this.applicantIn.birthday) === 'NaN-NaN-NaN NaN时') {
          this.$toast('投保人出生日期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      if (this.applicantInData === '其他' && this.applicantIn.validDate !== '') {
        if (checkFormat.getDate(this.applicantIn.validDate) === 'NaN-NaN-NaN NaN时') {
          this.$toast('投保人证件有效期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      
      if (this.applicantInData === '其他' && this.applicantIn.validDate !== '') {
        if (this.applicantIn.validDate < checkFormat.getTimeToDate(new Date())) {
          this.$toast('投保人证件有效期不能早于当前日期')
          return false
        }
      }
      if (!this.checkPhoneNum(this.carOwnerInfo.mobile, true)) {
        return false
      }
      if (!this.checkPhoneNum(this.recognizeeIn.mobile, true)) {
        return false
      }
      if (this.applicantInData === '其他' && !this.checkPhoneNum(this.applicantIn.mobile, true)) {
        return false
      }
      if (!this.checkIdentityNumber(this.ownerIdentifyType, this.carOwnerInfo.ownerIdentifyNumber, true)
      ) {
        return false
      }
      if (!this.checkIdentityNumber(this.RidentifyType, this.recognizeeIn.identifyNumber, true)) {
        return false
      }
      if (!this.checkIdentityNumber(this.AidentifyType, this.applicantIn.identifyNumber, true)) {
        return false
      }
      if (!checkFormat.isEmpty(this.recognizeeIn.iDStartDate) && !checkFormat.isEmpty(this.recognizeeIn.validDate)) {
        let ageDiff = checkFormat.calculateAge(this.recognizeeIn.identifyNumber, this.recognizeeIn.iDStartDate)
        if (ageDiff < 0) {
          this.$toast('请检查被保人证件起期是否正确')
          return false
        }
        const data = this.recognizeeIn.iDStartDate.replaceAll('-', '/')
        let validDate = checkFormat.checkValidDate(ageDiff, data)
        console.log(validDate, this.recognizeeIn.validDate)
        if (this.recognizeeIn.validDate !== validDate) {
          let message = this.yearDiff(ageDiff, '被保人')
          this.$toast(message)
          return false
        }
      }
      if (!checkFormat.isEmpty(this.applicantIn.iDStartDate) && !checkFormat.isEmpty(this.applicantIn.validDate)) {
        let ageDiff = checkFormat.calculateAge(this.applicantIn.identifyNumber, this.applicantIn.iDStartDate)
        if (ageDiff < 0) {
          this.$toast('请检查投保人证件起期是否正确')
          return false
        }
        const data = this.applicantIn.iDStartDate.replaceAll('-', '/')
        let validDate = checkFormat.checkValidDate(ageDiff, data)
        console.log(validDate, this.applicantIn.validDate)
        if (this.applicantIn.validDate !== validDate) {
          let message = this.yearDiff(ageDiff, '投保人')
          this.$toast(message)
          return false
        }
      }
      if (this.isMotorFace === '1') {
        console.log('跳转识别')
        this.$router.push(`/motor/personFace?isMotorFace=${this.isMotorFace}`)
      } else {
        this.temporary('save')
      }
      return
    },

    // 过滤证件有效期
    filterValiDate() {
      if (
        this.recognizeeIn.validDate === '长期' ||
        this.recognizeeIn.validDate === '9999-12-31'
      ) {
        this.checkbox = true
        this.startDis = true
        this.recognizeeIn.validDate = '9999-12-31'
      } else {
        this.startDis = false
        this.checkbox = false
      }
      if (
        this.applicantIn.validDate === '长期' ||
        this.applicantIn.validDate === '9999-12-31'
      ) {
        this.checkboxApp = true
        this.startDisApp = true
        this.applicantIn.validDate = '9999-12-31'
      } else {
        this.startDisApp = false
        this.checkboxApp = false
      }
      // console.log(this.recognizeeIn.validDate, '过滤证件有效期')
      // console.log(this.applicantIn.validDate, '过滤证件有效期')
    },
    // 性别
    getGender() {
      this.$http
        .post(api.getByCodeType, { codeType: 'SexCode' })
        .then((res) => {
          res.data.forEach((value) => {
            this.genderArr.push({
              codeCode: value.codeCode,
              codecname: value.codecname
            })
          })
          if (
            this.recognizeeIn.identifyNumber &&
            this.recognizeeIn.identifyNumber !== ''
          ) {
            if (
              parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 ===
              1
            ) {
              // console.log(this.genderArr,'this.gender');
              this.genderArr.forEach((value) => {
                if (value.codecname === '男') {
                  this.recognizeeIn.sex = value.codeCode
                  this.sex = value.codecname
                }
              })
            } else if (
              parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 ===
              0
            ) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '女') {
                  this.recognizeeIn.sex = value.codeCode
                  this.sex = value.codecname
                }
              })
            }
          }
          if (
            this.applicantIn.identifyNumber &&
            this.applicantIn.identifyNumber !== ''
          ) {
            if (
              parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 ===
              1
            ) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '男') {
                  this.applicantIn.sex = value.codeCode
                  this.sexs = value.codecname
                }
              })
            } else if (
              parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 ===
              0
            ) {
              this.genderArr.forEach((value) => {
                if (value.codecname === '女') {
                  this.applicantIn.sex = value.codeCode
                  this.sexs = value.codecname
                }
              })
            }
          }
          Toast.clear()
          this.switchs = false
        })
        .catch((error) => {
          console.log(error)
          this.switchs = false
        })
    },
    // 证件类型
    dictionary(codeType) {
      // console.log(codeType,'whatk--------ktktk');
      // console.log(this.status,'00ooo');
      const param = {
        codeType: codeType
      }
      this.columns = []
      this.switchs = true
      this.$http
        .post(api.getByCodeType, param)
        .then((res) => {
          Toast.clear()
          console.log(res, '0009994444444444');
          if (res.status === 200) {
            console.log(res.data, '00099999');
            console.log(this.status, '09999');
            this.columns = []
            if (
              this.status === 'IdentifyType1' ||
              this.status === 'IdentifyType2' ||
              this.status === 'IdentifyType3'
            ) {
              res.data = res.data.filter((item) => item.flag === 'Personal')
            } else if (this.status === 'sex' || this.status === 'tSex') {
              res.data = this.genderArr.filter(
                (item) => item.codecname !== '未说明'
              )
            }
            let IdentifyType = res.data
            console.log(IdentifyType, 'IdentifyType');
            IdentifyType.forEach((item) => {
              const obj = {
                text: item.codecname,
                code: item.codeCode
              }
              this.columns.push(obj)
            })
            console.log(this.columns, 'this.columns')
            // console.log(this.status, 'this.status')
            let datas
            switch (this.status) {
              case 'IdentifyType1':
                datas = this.carOwnerInfo.ownerIdentifyType
                break
              case 'IdentifyType2':
                datas = this.recognizeeIn.identifyType
                break
              case 'sex':
                datas = this.recognizeeIn.sex
                break
              case 'IdentifyType3':
                datas = this.applicantIn.identifyType
                break
              case 'tSex':
                datas = this.applicantIn.sex
                break
              case 'nationalityRec':
                datas = this.recognizeeIn.countryRegions
                break
              case 'nationalityApp':
                datas = this.applicantIn.countryRegions
                break
            }
            for (const i in this.columns) {
              if (datas === this.columns[i].code) {
                this.columns.defaultIndex = Number(i)
              }
            }
          }
          this.switchs = false
        })
        .catch((error) => {
          console.log(error)
          this.switchs = false
        })
    },
    idTab(index) {
      console.log(index, 'index')
      console.log(this.mortorQuery, 'index')
      this.idIndex = index
      if (Object.keys(this.mortorQuery).length > 0 && this.mortorQuery.itemFileDataList && this.mortorQuery.itemFileDataList.length > 0) {
        this.lastImgShow(this.mortorQuery.itemFileDataList)
      }
      // this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
    },
    idTabB(index) {
      this.idIndexB = index
      if (Object.keys(this.mortorQuery).length > 0 && this.mortorQuery.itemFileDataList.length > 0) {
        this.lastImgShow(this.mortorQuery.itemFileDataList)
      }
      // this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
    },
    idTabT(index) {
      this.idIndexT = index
    },
    clearCarOwnerInfo() {
      this.ownerIdentifyType = '身份证' // 车主证件类型
      this.carOwnerInfo = {
        vehicleOwnerNature: '1', // 车主性质
        carOwner: '', // 车主姓名
        ownerIdentifyType: '01', // 证件类型
        ownerIdentifyNumber: '', // 证件号码
        mobile: '', //
        email: '', //
        ownerAddress: '',
        frontFileId: '',
        backFileId: '',
        sex: '',
        iDStartDate: '', // 证件有效期起期
        birthday: '',
        validDate: ''
      }
    },
    clearRecognizeeIn() {
      console.log('clearRecognizeeIn')
      this.RidentifyType = '身份证' // 车主证件类型
      this.checkbox = false
      this.startDis = false
      this.provinceNameRec = ''
      this.recognizeeIn = {
        address: '',
        birthday: '',
        email: '',
        identifyNumber: '',
        identifyType: '01',
        insuredName: '',
        insuredRelationship: '', // 被保人关系 3同车主 4其他
        mobile: '',
        iDStartDate: '', // 证件有效期起期
        validDate: '',
        occupationCode: '0001001', // 被保人职业代码
        occupationName: '机关内勤(不从事凶险工作)', // 被保人职业名称
        sex: '',
        frontFileId: '',
        backFileId: '',
        nationality:'中国', // 国籍/地区
        countryRegions: 'CHN', // 国籍/地区code
        addressProvince:'', // 省
        addressPrefecture:'', // 市
        addressCounty: '' // 区
      }
      // this.recognizeeIn.identifyTypeCN = this.RidentifyType
    },
    clearApplicantIn() {
      this.startDisApp = false
      this.AidentifyType = '身份证' // 车主证件类型
      this.checkboxApp = false
      this.provinceNameApp = ''
      this.applicantIn.address = ''
      this.applicantIn.email = ''
      this.applicantIn.iDStartDate = ''
      this.applicantIn.validDate = ''
      this.applicantIn.frontFileId = ''
      this.applicantIn.backFileId = ''
      this.applicantIn.addressProvince = ''
      this.applicantIn.addressPrefecture = ''
      this.applicantIn.addressCounty = ''
      this.applicantIn.occupationCode = '0001001'
      this.applicantIn.occupationName = '机关内勤(不从事凶险工作)'
      this.applicantIn.nationality = '中国'
      this.applicantIn.countryRegions = 'CHN'
    },
    // popup身份证件类型
    onConfirm(value) {
      console.log(this.shipStatus, 'this.shipStatus');
      this.currentDate = new Date()
      if (this.shipStatus === 'c1') {
        this.ownerIdentifyType = value.text
        // this.carOwnerInfo.ownerIdentifyTypeCN = value.text
        this.carOwnerInfo.ownerIdentifyType = value.code
        if (this.recognizeeInData === '同车主') {
          this.RidentifyType = value.text
          this.recognizeeIn.identifyType = value.code
          // this.recognizeeIn.identifyTypeCN = value.text
        }
        // this.clearIdentify()
      } else if (this.shipStatus === 'r1t') {
        // this.clearRecogIdentify()
        // console.log(value.text, '009999888888');
        this.RidentifyType = value.text
        this.recognizeeIn.identifyType = value.code
        // this.recognizeeIn.identifyTypeCN = value.text
      } else if (this.shipStatus === 'sex') {
        this.genderRec = value.text
        this.recognizeeIn.sex = value.code
      } else if (this.shipStatus === 'b1') {
        if (this.recognizeeInData !== value.text) {
          this.clearRecognizeeIn()
          this.recognizeeInData = value.text
          this.recognizeeIn.insuredRelationship = value.code
          this.checkbox = false
          this.genderRec = ''
          this.startDis = false
          if (value.text === '其他') {
            this.reIdCarShow = true
            this.recognizeeIn.insuredRelationship = value.code
            if (this.applicantInData === '同被保人') {
              // this.syncRecogn()
              this.RidentifyType = this.AidentifyType
              this.recognizeeIn.insuredName = this.applicantIn.insuredName
              this.recognizeeIn.identifyNumber = this.applicantIn.identifyNumber
              this.recognizeeIn.sex = this.applicantIn.sex
              this.recognizeeIn.birthday = this.applicantIn.birthday
              this.recognizeeIn.mobile = this.applicantIn.mobile
            }
          } else if (value.text === '同车主') {
            this.reIdCarShow = false
            this.isRecognizeeIn = true
            if (this.applicantInData === '同被保人') {
              this.syncApp()
            }
          }
        } else {
          // console.log('whati');
        }
      } else if (this.shipStatus === 't1') {
        if (this.applicantInData !== value.text) {
          this.clearApplicantIn()
          this.applicantInData = value.text
          this.applicantIn.insuredRelationship = value.code
          this.genderApp = ''
          if (value.text === '同车主') {
            this.appIdCarShow = true
            if (this.newCinfo.name !== this.carOwnerInfo.carOwner || this.newCinfo.identifyNum !== this.carOwnerInfo.ownerIdentifyNumber || this.newCinfo.identifyType !== this.ownerIdentifyType) {
            Dialog.confirm({
                message: '投保人信息将同步车主'
              }).then(() => {
                this.syncApp()
                console.log(this.applicantIn, '123');
              }).catch((e) => {
                if(e === 'cancel'){
                  this.changOther()
                } 
              })
            } else {
              this.syncApp()
            }
          } 
          if (value.text === '同被保人') {
            console.log(this.recognizeeIn.insuredName);
            console.log(this.recognizeeIn.identifyNumber);
            console.log(this.RidentifyType);
            if (this.newCinfo.name !== this.recognizeeIn.insuredName || this.newCinfo.identifyNum !== this.recognizeeIn.identifyNumber || this.newCinfo.identifyType !== this.RidentifyType) {
            Dialog.confirm({
                message: '投保人信息将被保险人'
              }).then(() => {
                // this.recognizeeIn.frontFileId = ''
                // this.recognizeeIn.backFileId = ''
                // this.frontImageb = ''
                // this.showFrontImgb = false
                // this.backImageb = ''
                // this.showBackImgb = false
                this.syncRecogn()
              }).catch((e) => {
                if(e == 'cancel'){
                  this.changOther()
                }
              })
            } else {
              this.syncRecogn()
            }
          }
          if (value.text === '其他') {
            // console.log('走这个方法吗？？？？？');
            this.isRecognizeeIn = false
            const newCinfo = JSON.parse(localStorage.getItem('cInfo'))
            this.applicantIn.identifyNumber = newCinfo.identifyNum
            this.applicantIn.insuredName = newCinfo.name
            this.showPicker = false
            // this.isApplicantIn = true
            this.startTimePicker = false
            this.appIdCarShow = false
          } else {
            // this.applicantInassignment()
            // this.appIdCarShow = false
          }
        }
      } else if (this.shipStatus === 'tz1') {
        // this.clearAppIdentify()
        this.AidentifyType = value.text
        this.applicantIn.identifyType = value.code
        // console.log(this.AidentifyType,'this.AidentifyType');
      } else if (this.shipStatus === 'tSex') {
        if (this.AidentifyType === '身份证') {
          this.showPicker = false
          if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 1 && value.code === '2') {
            this.$toast('性别与身份证不一致')
            return
          }
          if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 0 && value.code === '1') {
            this.$toast('性别与身份证不一致')
            return
          }
        }
        this.genderApp = value.text
        this.applicantIn.sex = value.code
      } else if (this.shipStatus === 'nationalityRec') {
        this.recognizeeIn.nationality = value.text
        this.recognizeeIn.countryRegions  = value.code
      } else if (this.shipStatus === 'nationalityApp') {
        this.applicantIn.nationality = value.text
        this.applicantIn.countryRegions  = value.code
      }
      this.showPicker = false
    },
    syncApp() {
      console.log('同被保人的啊')
      console.log(this.applicantIn, 'applicantIn')
      // console.log(this.recognizeeIn, 'recognizeeIn')
      // console.log(this.carOwnerInfo, 'carOwnerInfo')
      this.ownerIdentifyType = this.AidentifyType
      this.carOwnerInfo.carOwner = this.applicantIn.insuredName
      this.carOwnerInfo.ownerIdentifyNumber = this.applicantIn.identifyNumber
      console.log(this.carOwnerInfo.carOwner, 'carOwner');
      console.log(this.carOwnerInfo.ownerIdentifyNumber, '0000');
      this.carOwnerInfo.mobile = this.applicantIn.mobile
      this.carOwnerInfo.email = this.applicantIn.email
      this.carOwnerInfo.ownerAddress = this.applicantIn.address
      this.carOwnerInfo.backFileId = this.applicantIn.backFileId
      this.carOwnerInfo.frontFileId = this.applicantIn.frontFileId
      if (this.AidentifyType === '身份证') {
        this.carOwnerInfo.birthday = checkFormat.identifyNumberToBirthday(this.applicantIn.identifyNumber)
      } else {
        this.carOwnerInfo.birthday = this.applicantIn.birthday
      }
      // console.log('进入syncApp',this.carOwnerInfo,this.applicantIn);

      console.log(this.carOwnerInfo, 'carOwnerInfo')
    },
    syncRecogn() {
      console.log('同被保人了吗')
      // console.log(this.applicantIn, 'applicantIn')
      // console.log(this.recognizeeIn, 'recognizeeIn')
 
      this.RidentifyType = this.AidentifyType
      this.recognizeeIn.insuredName = this.applicantIn.insuredName
      this.recognizeeIn.identifyNumber = this.applicantIn.identifyNumber
      this.recognizeeIn.mobile = this.applicantIn.mobile
      this.recognizeeIn.email = this.applicantIn.email
      this.recognizeeIn.address = this.applicantIn.address
      this.recognizeeIn.sex = this.applicantIn.sex
      this.recognizeeIn.occupationName = this.applicantIn.occupationName
      this.recognizeeIn.occupationCode = this.applicantIn.occupationCode

      this.provinceNameRec = this.provinceNameApp
      this.recognizeeIn.nationality = this.applicantIn.nationality
      this.recognizeeIn.countryRegions = this.applicantIn.countryRegions

      this.recognizeeIn.addressProvince = this.applicantIn.addressProvince
      this.recognizeeIn.addressPrefecture = this.applicantIn.addressPrefecture
      this.recognizeeIn.addressCounty = this.applicantIn.addressCounty

      this.recognizeeIn.backFileId = this.applicantIn.backFileId
      this.recognizeeIn.frontFileId = this.applicantIn.frontFileId

      this.recognizeeIn.iDStartDate = this.applicantIn.iDStartDate
      this.recognizeeIn.validDate = this.applicantIn.validDate
      // console.log(this.recognizeeIn, 'this.recognizeeIn');
      if (this.AidentifyType === '身份证') {
        this.recognizeeIn.birthday = checkFormat.identifyNumberToBirthday(this.applicantIn.identifyNumber)
      } else {
        this.recognizeeIn.birthday = this.applicantIn.birthday
      }
      this.filterValiDate()
    },
    // 投保人同被保人
    syncRegin() {
      this.applicantIn.mobile = this.recognizeeIn.mobile
      this.applicantIn.email = this.recognizeeIn.email
      this.applicantIn.address = this.recognizeeIn.address
      this.applicantIn.occupationName = this.recognizeeIn.occupationName
      this.applicantIn.occupationCode = this.recognizeeIn.occupationCode
      this.applicantIn.validDate = this.recognizeeIn.validDate
      this.applicantIn.iDStartDate = this.recognizeeIn.iDStartDate
      this.applicantIn.nationality = this.recognizeeIn.nationality
      this.applicantIn.countryRegions = this.recognizeeIn.countryRegions
      this.provinceNameApp = this.provinceNameRec
      this.applicantIn.addressProvince = this.recognizeeIn.addressProvince
      this.applicantIn.addressPrefecture = this.recognizeeIn.addressPrefecture
      this.applicantIn.addressCounty = this.recognizeeIn.addressCounty
    },
    assignment() {
      // console.log(this.carOwnerInfo, '进入assignment');
      // console.log(this.ownerIdentifyType);
      // console.log(this.AidentifyType);
      // console.log(this.applicantInData, 'this.applicantInData');
      // console.log(this.newCinfo);
      // console.log(this.newCinfo.name);
      // console.log(this.newCinfo.identifyType);
      // console.log(this.recognizeeInData);
      // console.log(this.applicantInData);
      if (this.recognizeeInData !== '其他' && this.applicantInData !== '同被保人') {
        if (this.carOwnerInfo.carOwner !== this.newCinfo.name || this.carOwnerInfo.ownerIdentifyNumber !== this.newCinfo.identifyNum || this.ownerIdentifyType !== this.newCinfo.identifyType) {
          // console.log('345555');
          this.changOther()
        } 
      }
      if (this.recognizeeInData === '同车主') {
        this.recognizeeIn.insuredName = this.carOwnerInfo.carOwner
        this.recognizeeIn.identifyType = this.carOwnerInfo.ownerIdentifyType
        this.recognizeeIn.identifyNumber = this.carOwnerInfo.ownerIdentifyNumber
        this.recognizeeIn.mobile = this.carOwnerInfo.mobile
        this.recognizeeIn.email = this.carOwnerInfo.email
        this.recognizeeIn.address = this.carOwnerInfo.ownerAddress
        this.recognizeeIn.frontFileId = this.carOwnerInfo.frontFileId
        this.recognizeeIn.backFileId = this.carOwnerInfo.backFileId
      }
      if (this.applicantInData === '同车主') {
        this.applicantIn.email = this.carOwnerInfo.email
        this.applicantIn.address = this.carOwnerInfo.ownerAddress
        this.applicantIn.frontFileId = this.carOwnerInfo.frontFileId
        this.applicantIn.backFileId = this.carOwnerInfo.backFileId
      }
      this.filterValiDate()
    },
    recognizeeInassignment() {
      // console.log(this.recognizeeIn, '30300303030');
      // console.log(this.applicantInData);
      if (this.recognizeeInData === '同车主') {
        this.recognizeeIn.insuredName = this.carOwnerInfo.carOwner
        this.recognizeeIn.identifyType = this.carOwnerInfo.ownerIdentifyType
        this.recognizeeIn.identifyNumber = this.carOwnerInfo.ownerIdentifyNumber
        this.recognizeeIn.mobile = this.carOwnerInfo.mobile
        this.recognizeeIn.email = this.carOwnerInfo.email
        this.recognizeeIn.address = this.carOwnerInfo.ownerAddress
        if (this.applicantInData === '同车主' || this.applicantInData === '同被保人') {
          this.syncRegin()
        } 
        // else if (this.applicantInData === '同被保人') {
        //   this.syncRecogn()
        // }
      } else {
        if (this.newCinfo.name !== this.recognizeeIn.insuredName || this.newCinfo.identifyNum !== this.recognizeeIn.identifyNumber || this.newCinfo.identifyType !== this.RidentifyType) {
          this.changOther()
        }
      }
      this.filterValiDate()
    },

    applicantInDataList() {
      // console.log(this.applicantIn, 'this.applicantIn');
      // console.log(this.carOwnerInfo.carOwner);
      // console.log(this.newCinfo.name);
      if (this.applicantInData === '同被保人') {
        if (this.recognizeeInData === '同车主') {
          this.ownerIdentifyType = this.AidentifyType
          this.carOwnerInfo.carOwner = this.applicantIn.insuredName
          this.carOwnerInfo.ownerIdentifyNumber = this.applicantIn.identifyNumber
          this.carOwnerInfo.mobile = this.applicantIn.mobile
          this.carOwnerInfo.email = this.applicantIn.email
          this.carOwnerInfo.ownerAddress = this.applicantIn.address
        }
      }
      this.filterValiDate()
    },
    unConfirm(event) {
      this.showPicker = false
      this.columns = []
      if (this.shipStatus === 'b1') {
        this.columns = [
          {
            text: '同车主',
            code: '3'
          },
          {
            text: '其他',
            code: '4'
          }
        ]
        for (const i in this.columns) {
          if (this.recognizeeIn.insuredRelationship === this.columns[i].code) {
            this.columns.defaultIndex = this.recognizeeIn.insuredRelationship * 1
          }
        }
      } else if (this.shipStatus === 't1') {
        // console.log(this.columns.defaultIndex,'w');
        this.columns = [
          {
            text: '同车主',
            code: '0'
          },
          {
            text: '同被保人',
            code: '1'
          },
          {
            text: '其他',
            code: '2'
          }
        ]
        this.columns.defaultIndex = 2
        // 有问题
      }
    },
    // 证件日期
    choiceValidity(no) {
      // console.log(no, this.startTimePicker, this.recognizeeInData, 'riq')
      // console.log(this.checkbox, 'this.checkbox');
      // console.log(this.checkboxApp, 'this.checkboxApp');
      if (no === 1 || no === 3 || no === 4 || no === 6) {
        if ((no === 6 && this.applicantInData === '其他') && ((no === 3 || no === 2) && this.recognizeeInData === '其他')) {
          this.startTimePicker = false
        } else {
          this.startTimePicker = true
        }
        this.maxDate = new Date()
        console.log(this.endTimePicker);
      } else {
        if ((no===2 && this.checkbox) || (no === 5 && this.checkboxApp)){
          this.endTimePicker = false
          this.startDis = false
        } else {
          this.endTimePicker = true
        }
      }
      this.timeStatus = no
    },
    // popup证件日期
    birthdaySure(time) {
      console.log(time, this.timeStatus, 'birthdaySure')
      // console.log(this.recognizeeInData, this.ownerIdentifyType, 'birthdddddaySure')
      if (this.timeStatus === 1) {
        this.recognizeeIn.iDStartDate = checkFormat.getTimeToDate(time)
        this.startTimePicker = false
      } else if (this.timeStatus === 2) {
        this.recognizeeIn.validDate = checkFormat.getTimeToDate(time)
        this.endTimePicker = false
      } else if (this.timeStatus === 3) {
        this.startTimePicker = false
        if (this.recognizeeInData === '同车主' && this.ownerIdentifyType === '身份证' && this.carOwnerInfo.identifyNumber !== '') {
          this.$toast('出生日期与身份证不一致')
          return false
        } else {
          this.$set(this.carOwnerInfo, 'birthday', checkFormat.getTimeToDate(time))
          this.$set(this.recognizeeIn, 'birthday', checkFormat.getTimeToDate(time))
          // console.log(this.carOwnerInfo.birthday);
          // console.log(this.recognizeeIn.birthday);
        }

        if (this.recognizeeInData === '其他' && this.RidentifyType === '身份证' && this.recognizeeIn.identifyNumber !== '') {
          this.isRecognizeeIn = true
          this.$toast('出生日期与身份证不一致')
          return false
        } else {
          this.isRecognizeeIn = false
          this.recognizeeIn.birthday = checkFormat.getTimeToDate(time)
        }
      } else if (this.timeStatus === 4) {
        this.applicantIn.iDStartDate = checkFormat.getTimeToDate(time)
        this.startTimePicker = false
      } else if (this.timeStatus === 5) {
        // console.log('eeeeee66666');
        this.applicantIn.validDate = checkFormat.getTimeToDate(time)
        this.endTimePicker = false
      } else if (this.timeStatus === 6) {
        this.applicantIn.birthday = checkFormat.getTimeToDate(time)
        this.startTimePicker = false
      }
      this.currentDate = new Date()
    },
    birthConfig() {
      if (
        this.timeStatus === 1 ||
        this.timeStatus === 3 ||
        this.timeStatus === 4 ||
        this.timeStatus === 6
      ) {
        this.startTimePicker = false
      } else if (this.timeStatus === 2 || this.timeStatus === 5) {
        this.endTimePicker = false
      }
      this.currentDate = new Date()
    },
    // 长期有效
    isCheckout(event, num) {
      console.log(event, num, 'isCheckout');
      if (num === 1) {
        // console.log('123');
        this.checkbox = event
        this.startDis = event
        this.checkbox = event
        this.recognizeeIn.validDate = this.checkbox ? '9999-12-31' : this.recognizeeIn.validDate
        // this.checkbox ? (this.recognizeeIn.validDate =this.checkbox === true? '9999-12-31' : this.recognizeeIn.validDate) : (this.recognizeeIn.validDate = '')
      }
      if (num === 2) {
        this.checkboxApp = event
        this.startDisApp = event
        this.checkboxApp = event
        console.log(this.checkboxApp)
        console.log(this.applicantIn.validDate)
        this.applicantIn.validDate = this.checkboxApp ? '9999-12-31' : this.applicantIn.validDate
        console.log(this.applicantIn.validDate, '1111')
        // this.checkboxApp ? (this.applicantIn.validDate = this.checkboxApp === true? '9999-12-31': this.applicantIn.validDate): (this.applicantIn.validDate = '')
      }
    },
    clearIdentify() {
      this.carOwnerInfo.ownerAddress = ''
      this.carOwnerInfo.ownerIdentifyNumber = ''
      // this.genderRec = ''
      this.recognizeeIn.birthday = ''
    },
    // 被保人
    clearRecogIdentify() {
      // console.log('clearRecogIdentify')
      this.recognizeeIn.identifyNumber = ''
      this.recognizeeIn.address = ''
      this.recognizeeIn.birthday = ''
      this.recognizeeIn.sex = ''
      // this.genderRec = ''
    },
    // 投保人
    clearAppIdentify() {
      this.applicantIn.identifyNumber = ''
      this.genderApp = ''
      this.applicantIn.birthday = ''
      this.applicantIn.address = ''
      this.applicantIn.sex = ''
    },
    // 证件类型选择
    ShowPapersTypePup(no) {
      if (no === 'tz1') {
        this.showPicker = false
      } else {
        this.showPicker = true
      }

      this.columns = []
      this.shipStatus = no
      if (no === 'c1') {
        this.status = 'IdentifyType1'
        this.dictionary('CERTI_TYPE')
      } else if (no === 'r1t') {
        this.status = 'IdentifyType2'
        this.dictionary('CERTI_TYPE')
      } else if (no === 'sex') {
        if (this.showPicker) {
          this.status = 'sex'
          this.dictionary('SexCode')
        }
      } else if (no === 'tz1') {
        this.showPicker = false
      } else if (no === 'tSex') {
        this.showPicker = false
      } else if (no === 'b1') {
        // 选择被保人类型
        this.columns = [
          {
            text: '同车主',
            code: '3'
          },
          {
            text: '其他',
            code: '4'
          }
        ]
        for (const i in this.columns) {
          if (this.recognizeeIn.insuredRelationship === this.columns[i].code) {
            this.columns.defaultIndex = Number(i)
          }
        }
      } else if (no === 't1') {
        // 选择投保人类型
        this.columns = [
          {
            text: '同车主',
            code: '0'
          },
          {
            text: '同被保人',
            code: '1'
          },
          {
            text: '其他',
            code: '2'
          }
        ]
      } else if (no === 'nationalityRec') {
        this.dictionary('CountryCode')
        this.status = 'nationalityRec'
      } else if (no === 'nationalityApp') {
        this.dictionary('CountryCode')
        this.status = 'nationalityApp'
      }
      for (const i in this.columns) {
        if (this.applicantIn.insuredRelationship === this.columns[i].code) {
          this.columns.defaultIndex = Number(i)
        }
      }
    },
    // 身份证正面
    frontHandleFile(event, no) {
      console.log('识别图片')
      const that = this
      const file = event.target.files[0]
      console.log(this.$refs.fileBtn, 'this.$refs.fileBtn')
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg'];
      const ext = file.name.toLowerCase().split('.').pop();
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      if (file.size > 20 * 1000 * 1000) {
        this.$toast('图片大小超过20M，请重新选择')
        return false
      } else {
        new Compressor(file, {
          quality: 0.5,
          maxWidth: 1200,
          success(result) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function(e) {
              const name = new Date().getTime()
              const param = {
                fileName: no + name + '.png',
                imageInBase64Format: e.target.result,
                serviceProvider: 'INTSIG', // 服务提供商
                businessType: 'OfficialWX-InsuredInfo', // 系统业务类型：0核心业务系统（0电子投保单；1电子保单；）1数字化营销平台销管中心（0电子合同），必传
                systemOrigin: 'OfficialWX', // 系统来源（0核心业务系统；1数字化营销平台销管中心），必传
                businessNo: checkFormat.generateUUID() // 系统业务唯一标识（投保单号、保单号、个人代理人唯一标识），必传
              }
              if (no === '1') {
                that.frontImage = e.target.result
                that.showFrontImg = true
                that.$nextTick(() => {
                  that.$refs.frontImage.style.width = ''
                  that.$refs.frontImage.style.height = ''
                  that.$refs.frontImage.style.transform = `rotate(${that.frontImageDeg}deg)`
                })
                that.frontImageDeg = 0
              } else if (no === '3') {
                that.frontImageb = e.target.result
                that.showFrontImgb = true
                that.$nextTick(() => {
                  that.$refs.frontImageb.style.width = ''
                  that.$refs.frontImageb.style.height = ''
                  that.$refs.frontImageb.style.transform = `rotate(${that.backImagebDeg}deg)`
                })
                that.backImagebDeg = 0
              }
              that.switchs = true
              that.$http
                .post(api.identification_cards, param)
                .then((res) => {
                  that.switchs = false
                  if (res.data.rtnCode === '0000') {
                    if (no === '1') {
                      that.carOwnerInfo.birthday = ''
                      that.carOwnerInfo.ownerIdentifyNumber = ''
                      that.carOwnerInfo.carOwner = res.data.name
                      if (res.data.idCardNumber && res.data.idCardNumber !== null && res.data.idCardNumber !== '' && res.data.idCardNumber !== undefined) {
                        that.carOwnerInfo.ownerIdentifyNumber = res.data.idCardNumber
                        that.ownerIdentifyType = '身份证' // 车主证件类型
                        that.carOwnerInfo.ownerIdentifyType = '01'
                        // console.log(that.carOwnerInfo.ownerIdentifyNumber, '进入方法了')
                      }
                      that.carOwnerInfo.ownerAddress =
                        res.data.residentialAddress
                      that.carOwnerInfo.frontFileId = res.data.fileId
                      that.carOwnerInfo.birthday = res.data.dateOfBirth
                      that.genderArr.forEach((itemA) => {
                        if (itemA.codecname === res.data.sex) {
                          that.carOwnerInfo.sex = itemA.codeCode
                        }
                      })
                      if (that.recognizeeInData === '同车主' || that.applicantInData === '同车主') {
                        that.recognizeeIn.frontFileId = res.data.fileId
                        // that.applicantIn.frontFileId = res.data.fileId
                      }
                    } else if (no === '3') {
                      that.RidentifyType = '身份证' // 车主证件类型
                      that.recognizeeIn.identifyType = '01'
                      // console.log('被保人的识别');
                      that.recognizeeIn.birthday = ''
                      that.recognizeeIn.identifyNumber = ''
                      that.recognizeeIn.insuredName = res.data.name
                      if (
                        res.data.idCardNumber &&
                        res.data.idCardNumber !== null &&
                        res.data.idCardNumber !== ''
                      ) {
                        that.recognizeeIn.identifyNumber =
                          res.data.idCardNumber
                      }
                      that.recognizeeIn.address = res.data.residentialAddress
                      that.recognizeeIn.frontFileId = res.data.fileId
                      that.recognizeeIn.birthday = res.data.dateOfBirth
                      that.genderRec = res.data.sex
                      that.genderArr.forEach((item) => {
                        if (item.codecname === res.data.sex) {
                          that.recognizeeIn.sex = item.codeCode
                        }
                      })
                    } else if (no === '5') {
                      that.applicantIn.birthday = ''
                      // that.recognizeeIn.identifyNumber = "";
                      that.applicantIn.identifyNumber = ''
                      that.applicantIn.insuredName = res.data.name
                      if (
                        res.data.idCardNumber &&
                        res.data.idCardNumber !== null &&
                        res.data.idCardNumber !== ''
                      ) {
                        that.applicantIn.identifyNumber = res.data.idCardNumber
                      }
                      that.applicantIn.address = res.data.residentialAddress
                      // that.applicantIn.frontFileId = res.data.fileId
                      that.applicantIn.birthday = res.data.dateOfBirth
                      that.genderApp = res.data.sex
                      that.genderArr.forEach((item) => {
                        if (item.codecname === res.data.sex) {
                          that.applicantIn.sex = item.codeCode
                        }
                      })
                    }
                    // console.log(res.data, '正后端返回的数据')
                    // console.log(that.carOwnerInfo, '车主正')
                    // console.log(that.recognizeeIn, '被保人正')
                    // console.log(that.applicantIn, '投保人正')
                    that.$toast({
                      message: '请注意核对自动识别出的信息是否正确',
                      position: 'top'
                    })
                    const objs = {
                      fileId: res.data.fileId,
                      fileType: '53',
                      type: 'front' + no,
                      fileName: param.fileName
                    }
                    const obj = {
                      fileId: res.data.fileId,
                      fileType: '53',
                      fileBase64: null,
                      fileName: param.fileName,
                      fileUrl: null
                    }
                    console.log(that.imgobjs, 'that.imgobjs')
                    if (that.imgobjs.length > 0) {
                      that.imgobjs.forEach((value, index) => {
                        if (value.type === objs.type) {
                          that.imgobjs.splice(index, 1)
                        }
                      })
                    }

                    that.imgobjs.push(objs)
                    if (that.$store.state.itemFileDataList && that.$store.state.itemFileDataList[0].length && that.$store.state.itemFileDataList[0].fileList) {
                      that.$store.state.itemFileDataList[0].fileList.unshift(obj)
                    }
                    console.log(that.$store.state.itemFileDataList[0].fileList, '======>');
                    console.log(that.imgobjs, 'that.imgobjs')
                    that.assignment()
                  } else {
                    that.$toast(res.data.rtnMsg)
                  }
                })
                .catch((err) => {
                  console.log(err)
                  that.switchs = false
                })
            }
          }
        })
      }
    },
    // 身份证反面
    backHandleFile(event, no) {
      const file = event.target.files[0]
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg'];
      const ext = file.name.toLowerCase().split('.').pop();
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      if (file.size > 20 * 1000 * 1000) {
        this.$toast('图片大小超过20M，请重新选择')
        return false
      } else {
        const that = this
        new Compressor(file, {
          quality: 0.5,
          maxWidth: 1200,
          success(result) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function(e) {
              const name = new Date().getTime()
              const param = {
                fileName: no + name + '.png',
                imageInBase64Format: e.target.result,
                serviceProvider: 'INTSIG', // 服务提供商
                businessType: 'OfficialWX-InsuredInfo', // 系统业务类型：0核心业务系统（0电子投保单；1电子保单；）1数字化营销平台销管中心（0电子合同），必传
                systemOrigin: 'OfficialWX', // 系统来源（0核心业务系统；1数字化营销平台销管中心），必传
                businessNo: checkFormat.generateUUID() // 系统业务唯一标识（投保单号、保单号、个人代理人唯一标识），必传
              }
              if (no === '2') {
                that.backImage = e.target.result
                that.showBackImg = true
                that.$nextTick(() => {
                  that.$refs.backImage.style.width = ''
                  that.$refs.backImage.style.height = ''
                  that.$refs.backImage.style.transform = `rotate(-${that.backImageDeg}deg)`
                })
                that.backImageDeg = 0
              } else if (no === '4') {
                that.checkbox = false
                that.backImageb = e.target.result
                that.showBackImgb = true
                that.$nextTick(() => {
                  that.$refs.backImageb.style.width = ''
                  that.$refs.backImageb.style.height = ''
                  that.$refs.backImageb.style.transform = `rotate(-${that.backImagebDeg}deg)`
                })
                that.backImagebDeg = 0
              } else if (no === '6') {
                that.checkboxApp = false
                that.backImaget = e.target.result
                that.showBackImgt = true
                that.$nextTick(() => {
                  that.$refs.backImaget.style.width = ''
                  that.$refs.backImaget.style.height = ''
                  that.$refs.backImaget.style.transform = `rotate(-${that.backImagetDeg}deg)`
                })
                that.backImagetDeg = 0
              }
              // let res = {}
              // res.data = {rtnCode:"0000",rtnMsg:"请求成功",validDate:"2023-12-13",iDStartDate:"2020-12-13",fileId:"0c4d92cc12754629a7b5e0660cb0f278"}
              that.switchs = true
              that.$http
                .post(api.oppositeIdentityCards, param)
                .then((res) => {
                  that.switchs = false
                  if (res.data.rtnCode === '0000') {
                    if (no === '2') {
                      that.carOwnerInfo.validDate = res.data.endDate
                      that.carOwnerInfo.iDStartDate = res.data.startDate
                      that.carOwnerInfo.backFileId = res.data.fileId
                      if (that.recognizeeInData === '同车主') {
                        that.recognizeeIn.validDate = res.data.endDate
                        that.recognizeeIn.iDStartDate = res.data.startDate
                        that.recognizeeIn.backFileId = res.data.fileId
                      }
                      if (that.applicantInData === '同车主') {
                        that.applicantIn.backFileId = res.data.fileId
                        that.applicantIn.validDate = res.data.endDate
                        that.applicantIn.iDStartDate = res.data.startDate
                      }
                    } else if (no === '4') {
                      that.recognizeeIn.validDate = res.data.endDate
                      that.recognizeeIn.iDStartDate = res.data.startDate
                      that.recognizeeIn.backFileId = res.data.fileId
                      if (that.applicantInData === '同被保人') {
                        that.applicantIn.validDate = res.data.endDate
                        that.applicantIn.iDStartDate = res.data.startDate
                      }
                    } else if (no === '6') {
                      that.applicantIn.validDate = res.data.endDate
                      that.applicantIn.iDStartDate = res.data.startDate
                      that.applicantIn.backFileId = res.data.fileId
                    }
                    // console.log(res.data, '反后端返回的数据')
                    // console.log(that.carOwnerInfo, '车主反')
                    // console.log(that.recognizeeIn, '被保人反')
                    // console.log(that.applicantIn, '投保人反')
                    that.$toast({
                      message: '请注意核对自动识别出的信息是否正确'
                    })
                    that.filterValiDate()
                    const obj = {
                      fileId: res.data.fileId,
                      fileType: '53',
                      type: 'back' + no,
                      fileName: param.fileName
                    }
                    if (that.imgobjs.length > 0) {
                      that.imgobjs.forEach((value, index) => {
                        // if (value.status === 3) {
                        //   that.imgobjs.splice(index, 1)
                        // }
                        if (value.type === obj.type) {
                          that.imgobjs.splice(index, 1)
                        }
                      })
                    }
                    that.imgobjs.push(obj)
                    // console.log(that.imgobjs,'that.imbackgobjs');
                  } else {
                    that.$toast(res.data.rtnMsg)
                  }
                })
                .catch((err) => {
                  console.log(err)
                  that.$toast('请求失败')
                  that.switchs = false
                })
            }
          }
        })
      }
    },

    // 验证手机号
    checkPhoneNum(param, judge) {
      if (judge) {
        if (param !== '') {
          if (checkFormat.checkPhone(param) === false) {
            this.$toast('请检查该手机号：“' + param + '”的格式是否正确')
            return false
          } else {
            return true
          }
        }
      }
    },
    // 校验邮箱
    checkEmail(email, judge) {
      if (judge) {
        if (email === undefined) {
          return true
        } else if (email !== '') {
          if (checkFormat.checkEmail(email) === false) {
            this.$toast('请检查该邮箱：“' + email + '”的格式是否正确')
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    },
    // 校验地址
    checkAddress(address, judge) {
      if (judge) {
        if (address.length < 12) {
          this.$toast('请检查地址：“ ' + address + ' ”是否完善至门牌号')
          return false
        } else {
          return true
        }
      }
    },
    // 身份证校验
    checkIdentityNumber(identy, IdentityNumber, judge) {
      console.log(identy, IdentityNumber, judge,'identyidenty');
      if (judge) {
        if (identy === '身份证') {
          if (checkFormat.isCardNo(IdentityNumber) === false) {
            this.$toast('请检查身份证号：“ ' + IdentityNumber + '” 是否正确')
            return false
          } else {
            return true
          }
        } else if (identy === '统一社会信用代码') {
          IdentityNumber = IdentityNumber.replace(/ /g, '')
          if (IdentityNumber.length > 15 && IdentityNumber.length < 19) {
            return true
          } else {
            this.$toast('请检查统一社会信用证号：“' + IdentityNumber + '”是否正确')
            return false
          }
        } else {
          return true
        }
      }
    },
    rotateImg(imgType) {
      const img = new Image()
      img.src = this[imgType]
      this[`${imgType}Deg`] += 90
      if (this[`${imgType}Deg`] >= 360) {
        this[`${imgType}Deg`] = 0
      }
      // console.log(this[`${imgType}Deg`], 'this[`${imgType}Deg`]')
      if (this[`${imgType}Deg`] === 90 || this[`${imgType}Deg`] === 270) {
        if (Number(img.width) > Number(img.height)) {
          this.$refs[imgType].style.height = `${0.62 * 209}px`
          this.$refs[imgType].style.width = '209px'
          this.$refs[imgType].style.marginTop = 126 / 3.1 + 'px'
        }
      } else {
        if (Number(img.width) > Number(img.height)) {
          this.$refs[imgType].style.width = img.width + 'px'
          this.$refs[imgType].style.height = img.height + 'px'
        }
        this.$refs[imgType].style.marginTop = 0
      }
      this.$refs[imgType].style.transform = `rotate(${
        this[`${imgType}Deg`]
      }deg)`
    },
    enlargeImg(imgType) {
      this.$ImagePreview([this[imgType]])
    },
    _filter(List, name, code) {
      let result = []
      for (let i = 0; i < List.length; i++) {
        if (code === List[i].codeCode) {
          result = List[i][name]
        }
      }
      return result
    },
    // 获取职业类别
    getCodeType() {
      const data = {
        codeType: 'Occupation'
      }
      this.$http.post(api.getCodeType, data).then((res) => {
        if (res.data.rtnCode === '0000' && res.data.result) {
          //  组装数据
          const levelData1 = res.data.result.filter(
            (item1) => item1.codeLevel === '1'
          )
          const levelData2 = res.data.result.filter(
            (item1) => item1.codeLevel === '2'
          )
          const levelData3 = res.data.result.filter(
            (item1) => item1.codeLevel === '3'
          )
          levelData1.forEach((el1) => {
            el1.levelTwoList = []
            levelData2.forEach((el2) => {
              if (el2.upperCode === el1.codeCode) {
                el1.levelTwoList.push(el2)
              }
              el2.levelThreeList = []
              levelData3.forEach((el3) => {
                if (el3.upperCode === el2.codeCode) {
                  el2.levelThreeList.push(el3)
                }
              })
            })
          })
          this.occupationList = levelData1
          // console.log(this.occupationList, '职业类别组装数据')
          if (this.$store.state.motorOrderDetail && Object.keys(this.$store.state.motorOrderDetail).length > 0 && this.$store.state.motorOrderDetail.carOwnerInfo && this.$store.state.motorOrderDetail.carOwnerInfo !== null && Object.keys(this.$store.state.motorOrderDetail.carOwnerInfo).length > 0) {
            this.getMortorQuery(this.$store.state.motorOrderDetail)
            this.mortorQuery = this.$store.state.motorOrderDetail
          }
        }
      })
    },
    // 展示职业类别弹框
    showOccupation(flag) {
      this.IsShowOccupation = true
      this.personFlag = flag
    },
    IsShowOccupationBtn() {
      this.IsShowOccupation = false
      this.showLevelName1 = true
    },
    // 弹框返回事件
    levelGoBack() {
      if (this.showLevelName1) {
        this.IsShowOccupation = false
        this.showLevelName1 = true
        this.showLevelName2 = false
        this.showLevelName3 = false
        this.levelName1 = ''
        this.levelName2 = ''
        this.levelName3 = ''
      }
      if (this.showLevelName2) {
        this.showLevelName1 = true
        this.showLevelName2 = false
        this.showLevelName3 = false
        this.levelName1 = ''
        this.levelName2 = ''
      }
      if (this.showLevelName3) {
        this.showLevelName1 = false
        this.showLevelName2 = true
        this.showLevelName3 = false
        this.levelName2 = ''
      }
    },
    // 职业类别一级选择
    getLevelName1(params, index) {
      this.levelName1 = params.codecname
      this.showLevelName1 = false
      this.showLevelName2 = true
      this.showLevelName3 = false
      this.level2List = this._filter(
        this.occupationList,
        'levelTwoList',
        params.codeCode
      )
    },
    // 职业类别二级选择
    getLevelName2(params, index) {
      this.levelName2 = params.codecname
      this.showLevelName1 = false
      this.showLevelName2 = false
      this.showLevelName3 = true
      this.level3List = this._filter(
        this.level2List,
        'levelThreeList',
        params.codeCode
      )
    },
    // 职业类别三级选择
    getLevelName3(params, index) {
      this[this.personFlag].occupationCode = params.codeCode
      this[this.personFlag].occupationName = params.codecname
      this.showLevelName1 = true
      this.showLevelName2 = false
      this.showLevelName3 = false
      this.IsShowOccupation = false
      this.levelName1 = ''
      this.levelName2 = ''
      this.levelName3 = ''
    },
    toOrderList() {
      this.temporary('orderList')
    }
  }
}
</script>
<style scoped lang="scss">
@import "./personInfo.scss";
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/personInfo/index.vue